(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["accordion"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__accordionOpenByDefaultBound) {
      return;
    }
    window.__accordionOpenByDefaultBound = true;

    function openDefaultAccordions() {
      document.querySelectorAll('accordion-disclosure[data-open-by-default]').forEach(function (el) {
        var details = el.querySelector('details');
        if (!details) {
          return;
        }
        details.open = true;
        details.setAttribute('aria-expanded', 'true');
        details.style.height = '';
        details.style.overflow = '';
        if (typeof el.open === 'function' && details.getAttribute('aria-expanded') !== 'true') {
          el.open({ instant: true });
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', openDefaultAccordions);
    } else {
      openDefaultAccordions();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-drawer-market-shipping-bar"] && !Shopify.designMode) return;
  try {
    (function () {
    var STORAGE_PREFIX = 'cart-drawer-market-shipping:';

    function prefersReducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function parseIntAttr(value) {
      var parsed = parseInt(value, 10);
      return isNaN(parsed) ? 0 : parsed;
    }

    function calcProgressPercent(totalCents, thresholdCents) {
      if (thresholdCents <= 0) {
        return 0;
      }

      return Math.min(100, Math.round((totalCents / thresholdCents) * 100));
    }

    function formatRemainingAmount(remainingCents, currencySymbol, currencyIso) {
      var options = {
        style: 'currency',
        currency: Shopify.currency.active
      };

      if (remainingCents % 100 === 0) {
        options.minimumFractionDigits = 0;
        options.maximumFractionDigits = 0;
      }

      var formatted = new Intl.NumberFormat(Shopify.locale, options)
        .format(remainingCents / 100);

      if (currencyIso) {
        formatted = formatted.split(currencyIso).join('').replace(/\s+/g, ' ').trim();
      }

      if (currencySymbol && formatted.indexOf(currencySymbol) !== -1) {
        var numericPart = formatted.split(currencySymbol).join('').trim();
        formatted = currencySymbol + numericPart;
      }

      return formatted.replace(/\$/g, '$$$$');
    }

    function readStoredProgress(marketHandle) {
      try {
        var raw = sessionStorage.getItem(STORAGE_PREFIX + marketHandle);
        return raw ? JSON.parse(raw) : null;
      } catch (error) {
        return null;
      }
    }

    function writeStoredProgress(marketHandle, percent) {
      try {
        sessionStorage.setItem(
          STORAGE_PREFIX + marketHandle,
          JSON.stringify({ percent: percent, updatedAt: Date.now() })
        );
      } catch (error) {
        return;
      }
    }

    class CartDrawerMarketShippingBar extends HTMLElement {
      connectedCallback() {
        this._fill = this.querySelector('.cart-drawer__market-shipping-fill');
        this._message = this.querySelector('.cart-drawer__market-shipping-message');
        this._track = this.querySelector('.cart-drawer__market-shipping-track');
        this._reducedMotion = prefersReducedMotion();
        this._onCartChange = this._handleCartChange.bind(this);

        var marketHandle = this.dataset.marketHandle || 'default';
        var thresholdCents = parseIntAttr(this.dataset.thresholdCents);
        var totalCents = parseIntAttr(this.dataset.totalCents);
        var targetPercent = calcProgressPercent(totalCents, thresholdCents);
        var stored = readStoredProgress(marketHandle);
        var fromPercent =
          stored && typeof stored.percent === 'number'
            ? stored.percent
            : parseIntAttr(this.dataset.progressPercent);

        this._applyProgress(fromPercent, false);
        this._sync(totalCents, thresholdCents, targetPercent, !this._reducedMotion && fromPercent !== targetPercent);

        document.addEventListener('cart:change', this._onCartChange);
      }

      disconnectedCallback() {
        document.removeEventListener('cart:change', this._onCartChange);

        var marketHandle = this.dataset.marketHandle;
        if (!marketHandle || !this._fill) {
          return;
        }

        var percent = parseInt(this._fill.style.width, 10);
        if (!isNaN(percent)) {
          writeStoredProgress(marketHandle, percent);
        }
      }

      _getThresholdCents() {
        return parseIntAttr(this.dataset.thresholdCents);
      }

      _applyProgress(percent, animate) {
        if (!this._fill) {
          return;
        }

        if (!animate || this._reducedMotion) {
          this._fill.style.transition = 'none';
        } else {
          this._fill.style.transition = '';
        }

        this._fill.style.width = percent + '%';

        if (!animate || this._reducedMotion) {
          var fill = this._fill;
          requestAnimationFrame(function () {
            fill.style.transition = '';
          });
        }
      }

      _updateMessage(totalCents, thresholdCents) {
        if (!this._message) {
          return;
        }

        if (totalCents >= thresholdCents) {
          this._message.textContent = this.dataset.reachedMessage || '';
          return;
        }

        var remainingCents = thresholdCents - totalCents;
        var formattedAmount = formatRemainingAmount(
          remainingCents,
          this.dataset.currencySymbol || '',
          this.dataset.currencyIso || ''
        );
        var template = this.dataset.unreachedMessage || '';
        this._message.innerHTML = template
          .replace(/\[remaining_amount\]/g, formattedAmount)
          .replace(/\{\{\s*remaining_amount\s*\}\}/g, formattedAmount);
      }

      _updateAria(percent) {
        if (this._track) {
          this._track.setAttribute('aria-valuenow', String(percent));
        }
      }

      _sync(totalCents, thresholdCents, targetPercent, animate) {
        var self = this;

        if (animate) {
          requestAnimationFrame(function () {
            self._applyProgress(targetPercent, true);
          });
        } else {
          this._applyProgress(targetPercent, false);
        }

        this._updateMessage(totalCents, thresholdCents);
        this._updateAria(targetPercent);
        this.dataset.totalCents = String(totalCents);
        this.dataset.progressPercent = String(targetPercent);

        if (this.dataset.marketHandle) {
          writeStoredProgress(this.dataset.marketHandle, targetPercent);
        }
      }

      _handleCartChange(event) {
        var cart = event.detail && event.detail.cart;
        if (!cart) {
          return;
        }

        var totalCents = parseIntAttr(String(cart.total_price));
        var thresholdCents = this._getThresholdCents();
        var targetPercent = calcProgressPercent(totalCents, thresholdCents);
        var currentPercent = parseIntAttr(this.dataset.progressPercent);

        if (this._message && targetPercent !== currentPercent) {
          this._message.classList.add('is-updating');
        }

        this._sync(totalCents, thresholdCents, targetPercent, !this._reducedMotion);

        var message = this._message;
        if (message) {
          window.setTimeout(function () {
            message.classList.remove('is-updating');
          }, 200);
        }
      }
    }

    if (!window.customElements.get('cart-drawer-market-shipping-bar')) {
      window.customElements.define('cart-drawer-market-shipping-bar', CartDrawerMarketShippingBar);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-drawer-reassurance-slider"] && !Shopify.designMode) return;
  try {
    (function () {
    function prefersReducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    class CartDrawerReassuranceCarousel extends HTMLElement {
      connectedCallback() {
        this._slides = Array.from(this.querySelectorAll('.cart-drawer__reassurance-slide'));
        this._currentIndex = Math.max(
          0,
          this._slides.findIndex(function (slide) {
            return slide.classList.contains('is-selected');
          })
        );

        if (this._slides.length === 0) {
          return;
        }

        this._onBlockSelect = this._handleBlockSelect.bind(this);
        this._onBlockDeselect = this._handleBlockDeselect.bind(this);
        this._onDrawerBeforeShow = this._preloadImages.bind(this);
        this._onDrawerRefreshed = this._handleDrawerRefreshed.bind(this);
        this._cartDrawer = this.closest('cart-drawer');

        if (this._cartDrawer) {
          this._cartDrawer.addEventListener('dialog:before-show', this._onDrawerBeforeShow);
          this._cartDrawer.addEventListener('cart-drawer:refreshed', this._onDrawerRefreshed);
        }

        if (Shopify.designMode) {
          this.addEventListener('shopify:block:select', this._onBlockSelect);
          this.addEventListener('shopify:block:deselect', this._onBlockDeselect);
        }

        this._startAutoplay();
      }

      disconnectedCallback() {
        this._stopAutoplay();

        if (this._cartDrawer) {
          this._cartDrawer.removeEventListener('dialog:before-show', this._onDrawerBeforeShow);
          this._cartDrawer.removeEventListener('cart-drawer:refreshed', this._onDrawerRefreshed);
        }

        if (Shopify.designMode) {
          this.removeEventListener('shopify:block:select', this._onBlockSelect);
          this.removeEventListener('shopify:block:deselect', this._onBlockDeselect);
        }
      }

      _preloadImages() {
        this.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
          img.removeAttribute('loading');
        });
      }

      _handleDrawerRefreshed() {
        if (this._cartDrawer && this._cartDrawer.open) {
          this._preloadImages();
        }
      }

      _getIntervalMs() {
        var seconds = parseInt(this.getAttribute('autoplay'), 10);
        return (isNaN(seconds) ? 3 : seconds) * 1000;
      }

      _startAutoplay() {
        this._stopAutoplay();

        if (this._slides.length <= 1 || !this.hasAttribute('autoplay') || prefersReducedMotion()) {
          return;
        }

        var self = this;
        this._timer = window.setInterval(function () {
          self._select((self._currentIndex + 1) % self._slides.length);
        }, this._getIntervalMs());
      }

      _stopAutoplay() {
        if (this._timer) {
          window.clearInterval(this._timer);
          this._timer = null;
        }
      }

      _select(index) {
        if (!this._slides[index] || index === this._currentIndex) {
          return;
        }

        this._slides[this._currentIndex].classList.remove('is-selected');
        this._currentIndex = index;
        this._slides[this._currentIndex].classList.add('is-selected');
      }

      _handleBlockSelect(event) {
        var slide = event.target.closest('.cart-drawer__reassurance-slide');

        if (!slide) {
          return;
        }

        this._stopAutoplay();
        this._select(this._slides.indexOf(slide));
      }

      _handleBlockDeselect() {
        this._startAutoplay();
      }
    }

    if (!window.customElements.get('cart-drawer-reassurance-carousel')) {
      window.customElements.define('cart-drawer-reassurance-carousel', CartDrawerReassuranceCarousel);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cross-sell"] && !Shopify.designMode) return;
  try {
    (function () {
    function unique(values) {
      var seen = {};
      return (values || []).filter(function (value) {
        var key = String(value || '');
        if (!key || seen[key]) {
          return false;
        }
        seen[key] = true;
        return true;
      });
    }

    function normalize(value) {
      return String(value || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase();
    }

    function typeMatches(itemType, exclusionType) {
      var item = normalize(itemType);
      var exclusion = normalize(exclusionType);
      if (!item || !exclusion) {
        return false;
      }
      return item === exclusion || item.indexOf(exclusion) !== -1 || exclusion.indexOf(item) !== -1;
    }

    function listHas(list, value) {
      var needle = normalize(value);
      return (list || []).some(function (entry) {
        return normalize(entry) === needle;
      });
    }

    function listsIntersect(required, actual) {
      if (!(required || []).length) {
        return true;
      }
      return required.some(function (value) {
        return listHas(actual, value);
      });
    }

    function sizeTokens(value) {
      return {
        raw: normalize(value),
        nums: String(value || '').match(/\d+/g) || [],
      };
    }

    function sizesShare(left, right) {
      return (left || []).some(function (leftValue) {
        var leftTokens = sizeTokens(leftValue);
        if (!leftTokens.raw) {
          return false;
        }
        return (right || []).some(function (rightValue) {
          var rightTokens = sizeTokens(rightValue);
          if (!rightTokens.raw) {
            return false;
          }
          if (leftTokens.raw === rightTokens.raw) {
            return true;
          }
          if (leftTokens.nums.length === 1 && rightTokens.nums.length === 1) {
            return leftTokens.nums[0] === rightTokens.nums[0];
          }
          if (leftTokens.nums.length === 1) {
            return rightTokens.nums.indexOf(leftTokens.nums[0]) !== -1;
          }
          if (rightTokens.nums.length === 1) {
            return leftTokens.nums.indexOf(rightTokens.nums[0]) !== -1;
          }
          return false;
        });
      });
    }

    function isEmptySizeValue(value) {
      var raw = normalize(value);
      return !raw || raw === 'default title' || raw === 'titre par defaut';
    }

    function variantHasSize(variant) {
      return (variant.sizes || []).some(function (value) {
        return !isEmptySizeValue(value);
      });
    }

    function textsShare(left, right) {
      return (left || []).some(function (value) {
        return listHas(right, value);
      });
    }

    function variantScore(variant, cartItem, rule) {
      var score = 0;
      var parts = [];
      if ((rule.sizes || []).length && sizesShare(variant.sizes, cartItem.sizes)) {
        score += 1;
        parts.push('taille');
      }
      if ((rule.materials || []).length && textsShare(variant.materials, cartItem.materials)) {
        score += 1;
        parts.push('matière');
      }
      if ((rule.colors || []).length && textsShare(variant.colors, cartItem.colors)) {
        score += 1;
        parts.push('coloris');
      }
      return { score: score, parts: parts };
    }

    function pickBestVariant(rule, matches, catalogProduct) {
      var variants = (catalogProduct && catalogProduct.variants) || rule.variants || [];
      if (!variants.length || !(matches || []).length) {
        return { fail: 'available' };
      }

      var sawSizedVariant = false;
      var sizeOk = false;
      var best = null;

      matches.forEach(function (item, itemIndex) {
        variants.forEach(function (variant, variantIndex) {
          if (!variant || !variant.id) {
            return;
          }

          if (variantHasSize(variant)) {
            sawSizedVariant = true;
            if (!sizesShare(variant.sizes, item.sizes)) {
              return;
            }
            sizeOk = true;
          } else {
            sizeOk = true;
          }

          if (!variant.available) {
            return;
          }

          var scored = variantScore(variant, item, rule);
          if (
            !best ||
            scored.score > best.score ||
            (scored.score === best.score && itemIndex < best.itemIndex) ||
            (scored.score === best.score && itemIndex === best.itemIndex && variantIndex < best.variantIndex)
          ) {
            best = {
              variant: variant,
              item: item,
              itemIndex: itemIndex,
              variantIndex: variantIndex,
              score: scored.score,
              parts: scored.parts,
            };
          }
        });
      });

      if (sawSizedVariant && !sizeOk) {
        return { fail: 'size' };
      }
      if (!best) {
        return { fail: 'available' };
      }
      return best;
    }

    function variantAcolytQuantity(entry) {
      if (!entry || entry.stock_acolyt == null || entry.stock_acolyt === '') {
        return null;
      }
      return Number(entry.stock_acolyt);
    }

    function variantFailLabel(fail) {
      if (fail === 'size') {
        return 'aucune variante à la bonne taille';
      }
      return 'aucune variante achetable';
    }

    function hasPositiveCriteria(rule) {
      return (rule.sizes || []).length > 0 || (rule.materials || []).length > 0 || (rule.colors || []).length > 0;
    }

    function isExcludedType(item, rule) {
      return (rule.exclusion_types || []).some(function (type) {
        return typeMatches(item.type, type);
      });
    }

    function itemQualifies(item, rule) {
      if (isExcludedType(item, rule)) {
        return false;
      }
      if (!hasPositiveCriteria(rule)) {
        return false;
      }
      return (
        listsIntersect(rule.sizes, item.sizes) &&
        listsIntersect(rule.materials, item.materials) &&
        listsIntersect(rule.colors, item.colors)
      );
    }

    function lineLabel(item, index) {
      var parts = ['#' + (index + 1), item.title || item.sku || 'sans titre'];
      if (item.type) {
        parts.push('type ' + item.type);
      }
      return parts.join(' · ');
    }

    function formatList(values) {
      var items = unique(values || []).filter(function (value) {
        return String(value || '').trim();
      });
      return items.length ? items.join(' / ') : '(vide)';
    }

    function itemQualifyDetail(item, rule) {
      var checks = [];

      if (isExcludedType(item, rule)) {
        var reason = 'type exclu (' + (item.type || 'vide') + ')';
        return { ok: false, reason: reason, checks: [reason] };
      }

      if (!hasPositiveCriteria(rule)) {
        var emptyReason = 'règle sans critère taille / matière / coloris';
        return { ok: false, reason: emptyReason, checks: [emptyReason] };
      }

      function pushCriterion(label, required, actual) {
        if (!(required || []).length) {
          return;
        }
        if (listsIntersect(required, actual)) {
          checks.push(label + ' ok (panier ' + formatList(actual) + ')');
        } else {
          checks.push(label + ' non : panier ' + formatList(actual) + ' ≠ règle ' + formatList(required));
        }
      }

      pushCriterion('taille', rule.sizes, item.sizes);
      pushCriterion('matière', rule.materials, item.materials);
      pushCriterion('coloris', rule.colors, item.colors);

      var ok = !checks.some(function (line) {
        return line.indexOf(' non : ') !== -1;
      });

      return {
        ok: ok,
        reason: checks.join(' · '),
        checks: checks,
      };
    }

    function compareReason(winner, loser) {
      var winnerSpec = ruleSpecificity(winner.rule);
      var loserSpec = ruleSpecificity(loser.rule);
      if (winnerSpec !== loserSpec) {
        return (
          'règle plus précise (' + winnerSpec + ' critère' + (winnerSpec > 1 ? 's' : '') + ' vs ' + loserSpec + ')'
        );
      }
      return 'ordre des configs';
    }

    function ruleLabel(rule) {
      return [rule.title || rule.handle || rule.gid, rule.product_handle].filter(Boolean).join(' / ');
    }

    function matchReason(item, rule) {
      var parts = [item.title || item.sku];
      if ((rule.sizes || []).length) {
        parts.push('taille ' + unique(item.sizes).join(' / '));
      }
      if ((rule.materials || []).length) {
        parts.push('matière ' + unique(item.materials).join(' / '));
      }
      if ((rule.colors || []).length) {
        parts.push('coloris ' + unique(item.colors).join(' / '));
      }
      if (item.type) {
        parts.push('type ' + item.type);
      }
      return parts.join(' · ');
    }

    function ruleProductId(rule) {
      if (rule.product_id) {
        return String(rule.product_id);
      }
      var gid = typeof rule.gid === 'string' ? rule.gid : '';
      var match = gid.match(/Product\/(\d+)/);
      return match ? match[1] : '';
    }

    function ruleSpecificity(rule) {
      return (
        ((rule.sizes || []).length ? 1 : 0) +
        ((rule.materials || []).length ? 1 : 0) +
        ((rule.colors || []).length ? 1 : 0)
      );
    }

    function blocKey(rule) {
      var value = Number(rule && rule.bloc);
      return isNaN(value) ? 0 : value;
    }

    function compareCandidates(a, b) {
      var specificity = ruleSpecificity(b.rule) - ruleSpecificity(a.rule);
      if (specificity) {
        return specificity;
      }
      return a.index - b.index;
    }

    function cartProductKey(item) {
      if (item && item.product_id) {
        return String(item.product_id);
      }
      if (item && item.variant_id) {
        return 'v:' + String(item.variant_id);
      }
      return 'sku:' + String((item && item.sku) || '');
    }

    function uniqueCartProductKeys(cart) {
      var keys = [];
      var seen = {};
      (cart || []).forEach(function (item) {
        var key = cartProductKey(item);
        if (!seen[key]) {
          seen[key] = true;
          keys.push(key);
        }
      });
      return keys;
    }

    function itemsForProductKey(cart, key) {
      return (cart || []).filter(function (item) {
        return cartProductKey(item) === key;
      });
    }

    function commitPickedVariant(rule, picked) {
      if (picked && picked.variant) {
        rule.variant_id = picked.variant.id;
        rule.variant_title = picked.variant.title || null;
        rule.available = true;
        rule.variant_fail = '';
        rule.variant_score = picked.score;
        rule.variant_score_parts = picked.parts;
        if (picked.variant.image) {
          rule.image = picked.variant.image;
        }
        rule.price = picked.variant.price;
        rule.compare_at_price = picked.variant.compare_at_price;
        rule.price_formatted = picked.variant.price_formatted;
        rule.compare_at_price_formatted = picked.variant.compare_at_price_formatted;
        return true;
      }
      rule.variant_id = null;
      rule.variant_title = null;
      rule.available = false;
      rule.variant_fail = (picked && picked.fail) || '';
      rule.variant_score = 0;
      rule.variant_score_parts = [];
      rule.price = null;
      rule.compare_at_price = null;
      rule.price_formatted = null;
      rule.compare_at_price_formatted = null;
      return false;
    }

    function variantOnSale(rule) {
      return rule && rule.compare_at_price != null && Number(rule.compare_at_price) > Number(rule.price || 0);
    }

    function stripTrailingZeroDecimals(formatted) {
      if (!formatted) {
        return '';
      }
      return String(formatted).replace(/([.,])00(?=\D|$)/g, '');
    }

    function renderProposalPrice(rule) {
      var priceEl = document.createElement('span');
      priceEl.className = 'cross-sell__price';
      if (!rule || (!rule.price_formatted && rule.price == null)) {
        return priceEl;
      }
      if (variantOnSale(rule)) {
        var compare = document.createElement('span');
        compare.className = 'cross-sell__price-compare';
        compare.textContent = stripTrailingZeroDecimals(rule.compare_at_price_formatted || '');
        priceEl.appendChild(compare);
        var sale = document.createElement('span');
        sale.className = 'cross-sell__price-sale';
        sale.textContent = stripTrailingZeroDecimals(rule.price_formatted || '');
        priceEl.appendChild(sale);
      } else {
        var regular = document.createElement('span');
        regular.className = 'cross-sell__price-regular';
        regular.textContent = stripTrailingZeroDecimals(rule.price_formatted || '');
        priceEl.appendChild(regular);
      }
      return priceEl;
    }

    function propose(cart, rules, catalog) {
      var cartIds = {};
      var cartVariantIds = {};
      (cart || []).forEach(function (item) {
        cartIds[String(item.product_id)] = true;
        if (item.variant_id) {
          cartVariantIds[String(item.variant_id)] = true;
        }
      });

      var catalogById = {};
      (catalog || []).forEach(function (product) {
        catalogById[String(product.id)] = product;
      });

      var results = (rules || []).map(function (rule, index) {
        var matches = (cart || []).filter(function (item) {
          return itemQualifies(item, rule);
        });
        var productId = ruleProductId(rule);
        var catalogProduct = productId ? catalogById[productId] : null;

        if (catalogProduct) {
          if (!rule.title) {
            rule.title = catalogProduct.title;
          }
          if (!rule.product_handle) {
            rule.product_handle = catalogProduct.handle;
          }
          if (!rule.image) {
            rule.image = catalogProduct.image;
          }
        }

        var picked = matches.length && catalogProduct ? pickBestVariant(rule, matches, catalogProduct) : null;
        var alreadyInCart = commitPickedVariant(rule, picked)
          ? Boolean(cartVariantIds[String(rule.variant_id)])
          : Boolean(productId && cartIds[productId]);

        return {
          index: index,
          rule: rule,
          matches: matches,
          proposed: false,
          superseded: false,
          alreadyInCart: Boolean(alreadyInCart),
          inCatalog: Boolean(catalogProduct),
          assignedKey: '',
          assignedItems: [],
          assignedOrder: 0,
          supersedeReason: '',
        };
      });

      var selectedIds = {};
      var productKeys = uniqueCartProductKeys(cart);

      Object.keys(
        results.reduce(function (blocs, result) {
          blocs[String(blocKey(result.rule))] = true;
          return blocs;
        }, {})
      )
        .sort(function (a, b) {
          return Number(a) - Number(b);
        })
        .forEach(function (bloc) {
          productKeys.forEach(function (productKey, productOrder) {
            var cartItems = itemsForProductKey(cart, productKey);
            var candidates = results
              .filter(function (result) {
                var productId = ruleProductId(result.rule);
                if (String(blocKey(result.rule)) !== String(bloc)) {
                  return false;
                }
                if (result.proposed || result.alreadyInCart || !result.inCatalog) {
                  return false;
                }
                if (productId && selectedIds[productId]) {
                  if (!result.supersedeReason) {
                    result.supersedeReason = 'doublon : produit déjà proposé';
                  }
                  return false;
                }
                return result.matches.some(function (item) {
                  return cartItems.indexOf(item) !== -1;
                });
              })
              .sort(compareCandidates);

            var chosen = null;
            candidates.forEach(function (candidate) {
              if (chosen) {
                return;
              }
              var matchLines = candidate.matches.filter(function (item) {
                return cartItems.indexOf(item) !== -1;
              });
              var catalogProduct = catalogById[ruleProductId(candidate.rule)];
              var picked = pickBestVariant(candidate.rule, matchLines, catalogProduct);
              if (!picked || !picked.variant) {
                return;
              }
              if (cartVariantIds[String(picked.variant.id)] || cartIds[ruleProductId(candidate.rule)]) {
                candidate.alreadyInCart = true;
                return;
              }
              commitPickedVariant(candidate.rule, picked);
              chosen = candidate;
              chosen.proposed = true;
              chosen.assignedKey = productKey;
              chosen.assignedItems = matchLines;
              chosen.assignedOrder = productOrder;
              var selectedId = ruleProductId(chosen.rule);
              if (selectedId) {
                selectedIds[selectedId] = true;
              }
            });

            candidates.forEach(function (candidate) {
              if (candidate === chosen || candidate.proposed) {
                return;
              }
              if (!candidate.supersedeReason) {
                candidate.supersedeReason = chosen
                  ? 'autre du même bloc pour ce produit (' + compareReason(chosen, candidate) + ')'
                  : 'autre du même bloc pour ce produit';
              }
            });
          });
        });

      results.forEach(function (result) {
        if (
          result.matches.length &&
          result.inCatalog &&
          !result.alreadyInCart &&
          result.rule.variant_id &&
          result.rule.available &&
          !result.proposed
        ) {
          result.superseded = true;
        }
      });

      return results;
    }

    function parseJsonScript(el) {
      try {
        return JSON.parse(el.textContent);
      } catch (error) {
        return null;
      }
    }

    function readEngine(root) {
      var dataEl = root.querySelector('.cross-sell__engine-data');
      var catalogEl = root.querySelector('.cross-sell__catalog');
      var catalogMetaEl = root.querySelector('.cross-sell__catalog-meta');
      var data = dataEl ? parseJsonScript(dataEl) : { cart: [] };
      var rules = [];

      root.querySelectorAll('.cross-sell__rule').forEach(function (el) {
        var rule = parseJsonScript(el);
        if (rule) {
          rule.sizes = unique(rule.sizes);
          rule.materials = unique(rule.materials);
          rule.colors = unique(rule.colors);
          rule.exclusion_types = unique(rule.exclusion_types);
          rules.push(rule);
        }
      });

      return {
        cart: ((data && data.cart) || []).map(function (item) {
          item.sizes = unique(item.sizes);
          item.materials = unique(item.materials);
          item.colors = unique(item.colors);
          return item;
        }),
        rules: rules,
        catalog: catalogEl ? parseJsonScript(catalogEl) || [] : [],
        catalogMeta: catalogMetaEl ? parseJsonScript(catalogMetaEl) || {} : {},
      };
    }

    function thumbSrcKey(src) {
      if (!src) {
        return '';
      }
      try {
        var url = new URL(src, window.location.href);
        return url.pathname + url.search;
      } catch (error) {
        return String(src);
      }
    }

    function markThumbLoaded(img) {
      img.classList.remove('is-loading');
      img.classList.add('is-loaded');
    }

    function attachThumbLoadState(img, src) {
      if (thumbCache.isReady(src) || (img.complete && img.naturalWidth > 0)) {
        thumbCache.markReady(src);
        markThumbLoaded(img);
        return;
      }

      img.classList.add('is-loading');
      img.addEventListener(
        'load',
        function () {
          thumbCache.markReady(src);
          if (img.decode) {
            img.decode().then(markThumbLoaded).catch(markThumbLoaded);
          } else {
            markThumbLoaded(img);
          }
        },
        { once: true }
      );
      img.addEventListener(
        'error',
        function () {
          img.classList.remove('is-loading');
        },
        { once: true }
      );
    }

    function thumbLayoutSize() {
      if (isMobileDrawerLayout()) {
        return { width: 98, height: 117 };
      }
      return { width: 125, height: 164 };
    }

    function thumbUrlForLayout(src) {
      if (!src || !isMobileDrawerLayout()) {
        return src;
      }
      var dims = thumbLayoutSize();
      try {
        var url = new URL(src, window.location.href);
        url.searchParams.set('width', String(dims.width));
        url.searchParams.set('height', String(dims.height));
        if (!url.searchParams.has('crop')) {
          url.searchParams.set('crop', 'center');
        }
        return url.toString();
      } catch (error) {
        return String(src)
          .replace(/([?&])width=\d+/i, '$1width=' + dims.width)
          .replace(/([?&])height=\d+/i, '$1height=' + dims.height);
      }
    }

    function renderThumb(src, alt, existingImg) {
      if (!src) {
        return null;
      }

      var layoutSrc = thumbUrlForLayout(src);
      var dims = thumbLayoutSize();
      var img = existingImg && existingImg.tagName === 'IMG' ? existingImg : document.createElement('img');
      img.className = 'cross-sell__thumb';
      img.width = dims.width;
      img.height = dims.height;
      img.alt = alt || '';
      img.loading = 'eager';
      img.decoding = 'async';

      var nextKey = thumbSrcKey(layoutSrc);
      var currentKey = existingImg ? thumbSrcKey(existingImg.getAttribute('src') || existingImg.src) : '';

      if (existingImg && currentKey === nextKey) {
        markThumbLoaded(img);
        return img;
      }

      if (thumbCache.isReady(layoutSrc)) {
        img.src = layoutSrc;
        markThumbLoaded(img);
        return img;
      }

      attachThumbLoadState(img, layoutSrc);
      img.src = layoutSrc;
      return img;
    }

    function proposalItemKey(result) {
      var rule = result.rule || {};
      return String(rule.handle || result.index) + ':' + String(rule.variant_id || '');
    }

    function updateProposalPrice(rule, productLine) {
      var priceEl = productLine.querySelector('.cross-sell__price');
      var next = renderProposalPrice(rule);
      if (priceEl) {
        priceEl.replaceWith(next);
      } else {
        productLine.appendChild(next);
      }
    }

    function getCrossSellLabels(root) {
      if (!root) {
        return { add: 'Add', addToCart: 'Add to cart' };
      }
      var addEl = root.querySelector('[data-cross-sell-string="add"]');
      var addToCartEl = root.querySelector('[data-cross-sell-string="add_to_cart"]');
      return {
        add: (addEl && addEl.textContent.trim()) || 'Add',
        addToCart: (addToCartEl && addToCartEl.textContent.trim()) || 'Add to cart',
      };
    }

    function crossSellAddButtonLabel(root) {
      var labels = getCrossSellLabels(root);
      return isMobileDrawerLayout() ? labels.add : labels.addToCart;
    }

    function refreshCrossSellAddButtonLabels(root) {
      if (!root) {
        return;
      }
      var label = crossSellAddButtonLabel(root);
      root.querySelectorAll('.cross-sell__add').forEach(function (button) {
        button.textContent = label;
      });
    }

    function syncProposalThumbAddable(li, rule, root) {
      var thumb = li && li.querySelector('.cross-sell__thumb');
      if (!thumb) {
        return;
      }
      var canAdd = !!(rule && rule.variant_id && rule.available !== false);
      thumb.classList.toggle('is-addable', canAdd);
      if (canAdd) {
        thumb.setAttribute('data-variant-id', String(rule.variant_id));
        thumb.setAttribute('role', 'button');
        thumb.setAttribute('tabindex', '0');
        thumb.setAttribute('aria-label', crossSellAddButtonLabel(root || li.closest('.cross-sell')));
      } else {
        thumb.removeAttribute('data-variant-id');
        thumb.removeAttribute('role');
        thumb.removeAttribute('tabindex');
        thumb.removeAttribute('aria-label');
      }
    }

    function updateProposalAddButton(rule, body, root) {
      var addButton = body.querySelector('.cross-sell__add');
      if (!addButton) {
        addButton = document.createElement('button');
        addButton.type = 'button';
        addButton.className = 'cross-sell__add';
        body.appendChild(addButton);
      }
      addButton.textContent = crossSellAddButtonLabel(root);
      if (rule.variant_id && rule.available !== false) {
        addButton.setAttribute('data-variant-id', String(rule.variant_id));
        addButton.disabled = false;
        addButton.removeAttribute('title');
      } else {
        addButton.removeAttribute('data-variant-id');
        addButton.disabled = true;
        addButton.title = 'Variante indisponible';
      }
    }

    function createOrUpdateProposalLi(result, existingLi, root) {
      var rule = result.rule;
      var li = existingLi || document.createElement('li');
      li.className = 'cross-sell__nested-item';
      li.setAttribute('data-proposal-key', proposalItemKey(result));

      var existingThumb = li.querySelector('.cross-sell__thumb');
      var thumb = renderThumb(rule.image, rule.title || '', existingThumb);
      if (thumb) {
        if (thumb !== existingThumb) {
          if (existingThumb) {
            existingThumb.replaceWith(thumb);
          } else {
            li.insertBefore(thumb, li.firstChild);
          }
        }
      } else if (existingThumb) {
        existingThumb.remove();
      }

      var body = li.querySelector('.cross-sell__nested-body');
      if (!body) {
        body = document.createElement('div');
        body.className = 'cross-sell__nested-body';
        li.appendChild(body);
      }

      var productLine = body.querySelector('.cross-sell__product-line');
      if (!productLine) {
        productLine = document.createElement('div');
        productLine.className = 'cross-sell__product-line';
        body.insertBefore(productLine, body.firstChild);
      }

      var heading = productLine.querySelector('.cross-sell__nested-heading');
      if (!heading) {
        heading = document.createElement('p');
        heading.className = 'cross-sell__nested-heading';
        productLine.insertBefore(heading, productLine.firstChild);
      }
      heading.textContent = rule.title || '';

      updateProposalPrice(rule, productLine);
      updateProposalAddButton(rule, body, root);
      syncProposalThumbAddable(li, rule, root);

      return li;
    }

    function renderProposalsDom(listEl, proposed, root) {
      var existingByKey = {};
      Array.prototype.forEach.call(listEl.children, function (li) {
        var key = li.getAttribute('data-proposal-key');
        if (key) {
          existingByKey[key] = li;
        }
      });

      var fragment = document.createDocumentFragment();
      proposed.forEach(function (result) {
        fragment.appendChild(createOrUpdateProposalLi(result, existingByKey[proposalItemKey(result)], root));
      });

      listEl.replaceChildren(fragment);
      refreshCrossSellAddButtonLabels(root);
    }

    function renderField(label, value, ddClass) {
      var field = document.createElement('div');
      field.className = 'cross-sell__field';
      var dt = document.createElement('dt');
      dt.textContent = label;
      var dd = document.createElement('dd');
      if (ddClass) {
        dd.className = ddClass;
      }
      dd.textContent = value || '(vide)';
      field.appendChild(dt);
      field.appendChild(dd);
      return field;
    }

    function displayList(values) {
      values = unique(values);
      return values.length ? values.join(' · ') : '(vide)';
    }

    function formatInventory(entries, total) {
      entries = entries || [];
      var parts = entries.map(function (entry) {
        return (entry.name || 'location') + ' : ' + String(entry.quantity != null ? entry.quantity : 0);
      });
      if (total != null && total !== '') {
        parts.push('inventory_quantity : ' + String(total));
      }
      return parts.length ? parts.join(' · ') : '(vide)';
    }

    function itemAcolytQuantity(item) {
      return variantAcolytQuantity(item);
    }

    function stockProxyUrl(root) {
      var path = (root && root.getAttribute('data-stock-proxy')) || '/apps/rivecour-stock-boutique';
      if (path.charAt(0) !== '/') {
        path = '/' + path;
      }
      return path;
    }

    function collectStockVariantIds(cart) {
      var ids = {};
      (cart || []).forEach(function (item) {
        if (item && item.variant_id) {
          ids[String(item.variant_id)] = true;
        }
      });
      return Object.keys(ids);
    }

    function inventoryEntriesFromApi(row) {
      if (!row) {
        return [];
      }
      var locations = row.locations || {};
      var entries = [];
      if (locations.bon_marche != null && locations.bon_marche !== '') {
        entries.push({ name: 'Bon Marché', quantity: Number(locations.bon_marche) || 0 });
      }
      if (locations.marais != null && locations.marais !== '') {
        entries.push({ name: 'Marais', quantity: Number(locations.marais) || 0 });
      }
      entries.push({ name: 'Acolyt', quantity: Number(row.stock_acolyt) || 0 });
      return entries;
    }

    function applyApiStock(target, row) {
      if (!target || !row) {
        return;
      }
      target.stock_acolyt = row.stock_acolyt;
      target.stock_api = row.stock;
      target.stock_api_cached = row.is_cached;
      target.inventory_api = inventoryEntriesFromApi(row);
    }

    function overlayEngineStocks(engine, byId) {
      byId = byId || {};
      (engine.cart || []).forEach(function (item) {
        applyApiStock(item, byId[String(item.variant_id)]);
      });
    }

    function fetchStockBatch(root, variantIds) {
      var ids = unique(variantIds);
      if (!ids.length) {
        return Promise.resolve({ byId: {}, error: '', fetched: false, ids: [] });
      }
      return fetch(stockProxyUrl(root), {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ variant_ids: ids }),
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error('HTTP ' + response.status);
          }
          return response.json();
        })
        .then(function (data) {
          var byId = {};
          if (data && data.results && typeof data.results === 'object') {
            Object.keys(data.results).forEach(function (key) {
              byId[String(key)] = data.results[key];
            });
          } else if (data && data.variant_id) {
            byId[String(data.variant_id)] = data;
          }
          return { byId: byId, error: '', fetched: true, ids: ids };
        })
        .catch(function (error) {
          return {
            byId: {},
            error: String((error && error.message) || error || 'fetch'),
            fetched: false,
            ids: ids,
          };
        });
    }

    var stockCache = (function () {
      var byId = {};
      var lastCartVariantKey = '';

      function cartVariantKey(variantIds) {
        return unique(variantIds)
          .slice()
          .sort(function (a, b) {
            return String(a).localeCompare(String(b), undefined, { numeric: true });
          })
          .join(',');
      }

      function has(id) {
        return byId[String(id)] != null;
      }

      function hasAll(variantIds) {
        var ids = unique(variantIds);
        if (!ids.length) {
          return true;
        }
        return ids.every(function (id) {
          return has(id);
        });
      }

      function missingIds(variantIds) {
        return unique(variantIds).filter(function (id) {
          return !has(id);
        });
      }

      function get(id) {
        return byId[String(id)] || null;
      }

      function setMany(entriesById) {
        Object.keys(entriesById || {}).forEach(function (key) {
          var row = entriesById[key];
          if (row) {
            byId[String(key)] = row;
          }
        });
      }

      function buildByIdForIds(variantIds) {
        var result = {};
        unique(variantIds).forEach(function (id) {
          if (has(id)) {
            result[String(id)] = get(id);
          }
        });
        return result;
      }

      function setCartKey(variantIds) {
        lastCartVariantKey = cartVariantKey(variantIds);
      }

      return {
        hasAll: hasAll,
        missingIds: missingIds,
        get: get,
        setMany: setMany,
        buildByIdForIds: buildByIdForIds,
        setCartKey: setCartKey,
        cartVariantKey: cartVariantKey,
        getLastCartVariantKey: function () {
          return lastCartVariantKey;
        },
      };
    })();

    var thumbCache = (function () {
      var ready = {};

      function markReady(src) {
        if (src) {
          ready[thumbSrcKey(src)] = true;
        }
      }

      function isReady(src) {
        return !!(src && ready[thumbSrcKey(src)]);
      }

      function preload(src) {
        if (!src || isReady(src)) {
          return Promise.resolve(src);
        }

        return new Promise(function (resolve) {
          var img = new Image();
          img.onload = function () {
            var finalize = function () {
              markReady(src);
              resolve(src);
            };
            if (img.decode) {
              img.decode().then(finalize).catch(finalize);
            } else {
              finalize();
            }
          };
          img.onerror = function () {
            resolve(src);
          };
          img.src = src;
        });
      }

      function preloadMany(urls) {
        var uniqueUrls = {};
        (urls || []).forEach(function (url) {
          if (url) {
            uniqueUrls[url] = true;
          }
        });
        return Promise.all(Object.keys(uniqueUrls).map(preload));
      }

      function warmFromCatalog(catalog) {
        var urls = [];
        (catalog || []).forEach(function (product) {
          if (product.image) {
            urls.push(product.image);
          }
          (product.variants || []).forEach(function (variant) {
            if (variant.image) {
              urls.push(variant.image);
            }
          });
        });
        if (!urls.length) {
          return;
        }
        var run = function () {
          preloadMany(urls);
        };
        if (typeof requestIdleCallback === 'function') {
          requestIdleCallback(run);
        } else {
          setTimeout(run, 0);
        }
      }

      return {
        isReady: isReady,
        markReady: markReady,
        preload: preload,
        preloadMany: preloadMany,
        warmFromCatalog: warmFromCatalog,
      };
    })();

    function logStockCache(root, message, detail) {
      if (!root || root.getAttribute('data-debug-stock') !== 'true') {
        return;
      }
      if (typeof console !== 'undefined' && console.log) {
        console.log('[cross-sell stock]', message, detail || '');
      }
    }

    function fetchStockBatchCached(root, variantIds) {
      variantIds = unique(variantIds || []);
      stockCache.setCartKey(variantIds);

      if (!variantIds.length) {
        return Promise.resolve({
          byId: {},
          error: '',
          fetched: false,
          ids: [],
          cacheHit: true,
          cacheDelta: [],
        });
      }

      var missingIds = stockCache.missingIds(variantIds);
      if (!missingIds.length) {
        logStockCache(root, 'cache hit', {
          cartKey: stockCache.getLastCartVariantKey(),
          ids: variantIds,
        });
        return Promise.resolve({
          byId: stockCache.buildByIdForIds(variantIds),
          error: '',
          fetched: false,
          ids: variantIds,
          cacheHit: true,
          cacheDelta: [],
        });
      }

      logStockCache(root, 'cache miss', {
        cartKey: stockCache.getLastCartVariantKey(),
        delta: missingIds,
      });

      return fetchStockBatch(root, missingIds).then(function (stock) {
        if (stock.fetched && stock.byId) {
          stockCache.setMany(stock.byId);
        }

        var mergedById = stockCache.buildByIdForIds(variantIds);
        if (stock.error) {
          logStockCache(root, 'fetch failed, fail-open', {
            error: stock.error,
            cachedIds: Object.keys(mergedById),
          });
        }

        return {
          byId: mergedById,
          error: stock.error,
          fetched: stock.fetched,
          ids: variantIds,
          cacheHit: false,
          cacheDelta: missingIds,
        };
      });
    }

    var lastEngineSnapshot = {
      cart: [],
      rules: [],
      catalog: [],
      catalogMeta: {},
    };
    function isRootCartProcessed(root, cartKey) {
      return !!(root && root.getAttribute('data-cross-sell-cart-key') === cartKey);
    }

    function markRootCartProcessed(root, cartKey) {
      if (root) {
        root.setAttribute('data-cross-sell-cart-key', cartKey);
        root.removeAttribute('data-cross-sell-pending-key');
      }
    }

    function isRootCartPending(root, cartKey) {
      return !!(root && root.getAttribute('data-cross-sell-pending-key') === cartKey);
    }

    function setRootCartPending(root, cartKey) {
      if (root) {
        root.setAttribute('data-cross-sell-pending-key', cartKey);
      }
    }

    function cloneCartLine(item) {
      return {
        product_id: item.product_id,
        variant_id: item.variant_id,
        title: item.title,
        sku: item.sku,
        type: item.type,
        sizes: unique(item.sizes || []),
        materials: unique(item.materials || []),
        colors: unique(item.colors || []),
        inventory_quantity: item.inventory_quantity,
        inventory: item.inventory || [],
        stock_acolyt: item.stock_acolyt,
        stock_api: item.stock_api,
        stock_api_cached: item.stock_api_cached,
        inventory_api: item.inventory_api,
      };
    }

    function saveEngineSnapshot(engine) {
      if (!engine) {
        return;
      }
      lastEngineSnapshot = {
        cart: (engine.cart || []).map(cloneCartLine),
        rules: engine.rules || [],
        catalog: engine.catalog || [],
        catalogMeta: engine.catalogMeta || {},
      };
    }

    function buildCartMutationKey(cartOrItems) {
      var items = cartOrItems && cartOrItems.items ? cartOrItems.items : cartOrItems || [];
      var variantIds = items
        .map(function (item) {
          return item && item.variant_id ? String(item.variant_id) : '';
        })
        .filter(Boolean)
        .sort();
      var count = cartOrItems && cartOrItems.items ? cartOrItems.item_count : items.length;
      return String(count || 0) + ':' + variantIds.join(',');
    }

    function cartOptionKey(name) {
      return String(name || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase();
    }

    function normalizeCartLineFromShopify(item) {
      var sizes = [];
      var materials = [];
      var colors = [];

      if (item && item.options_with_values && item.options_with_values.length) {
        item.options_with_values.forEach(function (opt) {
          var key = cartOptionKey(opt.name);
          var value = opt.value;
          if (!value) {
            return;
          }
          if (key === 'taille' || key === 'size') {
            sizes.push(value);
          } else if (key === 'matiere' || key === 'matter' || key === 'material') {
            materials.push(value);
          } else if (key === 'couleur' || key === 'color' || key === 'coloris') {
            colors.push(value);
          }
        });
      }

      return {
        product_id: item.product_id,
        variant_id: item.variant_id,
        title: item.product_title || item.title || '',
        sku: item.sku || (item.variant_id ? String(item.variant_id) : ''),
        type: item.product_type || item.type || '',
        sizes: unique(sizes),
        materials: unique(materials),
        colors: unique(colors),
        inventory_quantity: 0,
        inventory: [],
      };
    }

    function normalizeCartFromShopify(cart) {
      return (cart && cart.items ? cart.items : []).map(normalizeCartLineFromShopify);
    }

    function preferEnrichedCartMetadata(shopifyValues, enrichedValues) {
      var enriched = unique(enrichedValues || []);
      if (enriched.length) {
        return enriched;
      }
      return unique(shopifyValues || []);
    }

    function buildPreviousCartLookup(previousCarts) {
      var byVariant = {};
      (previousCarts || []).forEach(function (cart) {
        (cart || []).forEach(function (item) {
          if (item && item.variant_id) {
            byVariant[String(item.variant_id)] = item;
          }
        });
      });
      return byVariant;
    }

    function enrichCartLines(cartLines, previousCarts) {
      var byVariant = buildPreviousCartLookup(previousCarts);

      return (cartLines || []).map(function (line) {
        var prev = byVariant[String(line.variant_id)];
        if (!prev) {
          return line;
        }
        return {
          product_id: line.product_id,
          variant_id: line.variant_id,
          title: line.title || prev.title,
          sku: line.sku || prev.sku,
          type: line.type || prev.type,
          sizes: preferEnrichedCartMetadata(line.sizes, prev.sizes),
          materials: preferEnrichedCartMetadata(line.materials, prev.materials),
          colors: preferEnrichedCartMetadata(line.colors, prev.colors),
          inventory_quantity: prev.inventory_quantity != null ? prev.inventory_quantity : line.inventory_quantity,
          inventory: prev.inventory && prev.inventory.length ? prev.inventory : line.inventory,
          stock_acolyt: prev.stock_acolyt,
          stock_api: prev.stock_api,
          stock_api_cached: prev.stock_api_cached,
          inventory_api: prev.inventory_api,
        };
      });
    }

    function writeEngineCart(root, cart) {
      var dataEl = root && root.querySelector('.cross-sell__engine-data');
      if (!dataEl) {
        return;
      }
      var payload = parseJsonScript(dataEl) || {};
      payload.cart = (cart || []).map(cloneCartLine);
      dataEl.textContent = JSON.stringify(payload);
    }

    function buildEngineFromRoot(root, shopifyCart) {
      var domEngine = readEngine(root);
      var engine = {
        cart: domEngine.cart,
        rules: domEngine.rules.length ? domEngine.rules : lastEngineSnapshot.rules,
        catalog: domEngine.catalog.length ? domEngine.catalog : lastEngineSnapshot.catalog,
        catalogMeta:
          domEngine.catalogMeta && domEngine.catalogMeta.missing !== true
            ? domEngine.catalogMeta
            : lastEngineSnapshot.catalogMeta,
      };

      if (shopifyCart && shopifyCart.items) {
        var previousCarts = [lastEngineSnapshot.cart, domEngine.cart];
        engine.cart = enrichCartLines(normalizeCartFromShopify(shopifyCart), previousCarts);
        writeEngineCart(root, engine.cart);
      }

      return engine;
    }

    function runEnginePipeline(root, engine, options) {
      options = normalizeInitOptions(options);
      var run = (Number(root.getAttribute('data-engine-run')) || 0) + 1;
      root.setAttribute('data-engine-run', String(run));
      var variantIds = collectStockVariantIds(engine.cart);
      var cacheComplete = stockCache.hasAll(variantIds);
      var keepList = options.silent && proposalsListHasItems(root);

      if (!(options.silent && (cacheComplete || keepList))) {
        setProposalsPending(root, 'Vérification des stocks…', options);
      }

      return fetchStockBatchCached(root, variantIds)
        .then(function (stock) {
          if (String(root.getAttribute('data-engine-run')) !== String(run)) {
            return null;
          }
          overlayEngineStocks(engine, stock.byId || {});
          engine.apiStock = stock;
          var results = propose(engine.cart, engine.rules, engine.catalog);
          var sfs = detectShipFromStore(engine.cart);
          engine.shipFromStore = sfs.shipFromStore;
          engine.shipFromStoreItems = sfs.items;
          renderProposals(root, results, sfs, options);
          fillDebug(engine, results);
          bindAddToCart(root);
          saveEngineSnapshot(engine);
          thumbCache.warmFromCatalog(engine.catalog);
          return engine;
        })
        .catch(function (error) {
          logStockCache(root, 'pipeline failed, UI kept', error);
          return null;
        });
    }

    function refreshCrossSellFromCart(root, shopifyCart, options) {
      if (!root) {
        return Promise.resolve(null);
      }
      options = options || {};
      var cartKey =
        options.cartKey ||
        (shopifyCart ? buildCartMutationKey(shopifyCart) : buildCartMutationKey({ items: readEngine(root).cart }));

      if (shouldSkipCrossSellCartRefresh(root, cartKey, options)) {
        return Promise.resolve(null);
      }

      setRootCartPending(root, cartKey);
      var engine = buildEngineFromRoot(root, shopifyCart);

      return runEnginePipeline(root, engine, { silent: true })
        .then(function (result) {
          if (result) {
            markRootCartProcessed(root, cartKey);
          } else if (root) {
            root.removeAttribute('data-cross-sell-pending-key');
          }
          return result;
        })
        .catch(function (error) {
          if (root) {
            root.removeAttribute('data-cross-sell-pending-key');
          }
          logStockCache(root, 'refresh failed, UI kept', error);
          return null;
        });
    }

    var pendingDrawerCartMutation = null;

    function onCartChangeForCrossSell(event) {
      var cart = event && event.detail && event.detail.cart;
      if (!cart) {
        return;
      }
      var cartKey = buildCartMutationKey(cart);
      pendingDrawerCartMutation = { cart: cart, cartKey: cartKey };

      document.querySelectorAll('.cross-sell').forEach(function (root) {
        if (root.closest('cart-drawer') && root.classList.contains('cross-sell--drawer-items')) {
          return;
        }
        refreshCrossSellFromCart(root, cart, { cartKey: cartKey });
      });
    }

    function normalizeInitOptions(options) {
      options = options || {};
      return { silent: options.silent === true };
    }

    function proposalsListHasItems(root) {
      var listEl = root.querySelector('.cross-sell__proposals .cross-sell__nested-list');
      if (!listEl || listEl.hidden) {
        return false;
      }
      return listEl.children.length > 0;
    }

    var preservedDrawerCrossSell = null;
    var preservedDrawerCrossSellVisible = false;
    var preservedDrawerBodyScrollTop = 0;

    function isMobileDrawerLayout() {
      return window.matchMedia('(max-width: 999px)').matches;
    }

    function isDrawerInlineCrossSell(root) {
      return !!(root && root.classList.contains('cross-sell--drawer-items'));
    }

    function getDrawerCrossSellRoot(drawer) {
      drawer = drawer || document.querySelector('cart-drawer');
      return drawer ? drawer.querySelector('.cross-sell--drawer-items') : null;
    }

    function shouldSkipCrossSellCartRefresh(root, cartKey, options) {
      if (!root) {
        return true;
      }
      if (options && options.force) {
        return false;
      }
      if (root.hidden) {
        return false;
      }
      return isRootCartProcessed(root, cartKey) || isRootCartPending(root, cartKey);
    }

    function getCartDrawerBodyEl() {
      var drawer = document.querySelector('cart-drawer');
      if (!drawer || !drawer.shadowRoot) {
        return null;
      }
      return drawer.shadowRoot.querySelector('[part="body"]');
    }

    var mobileCrossSellLayoutObserver = null;
    var mobileCrossSellLayoutRaf = 0;
    var desktopCrossSellAnchorRaf = 0;
    var DESKTOP_CROSS_SELL_WIDTH = 180;

    // Ancre le panneau desktop au drawer (plein haut). Prestige applique souvent un
    // transform sur [part=content] (anim) et/ou [part=body] : ce nœud devient alors le
    // containing-block de position:fixed. Des coords viewport (left = content.left - 180)
    // placent le panneau hors écran (ex. 1470+1290) → flash puis disparition.
    function clearDesktopCrossSellAnchor(root) {
      if (!root) {
        return;
      }
      ['top', 'bottom', 'left', 'right', 'width', 'height', 'position'].forEach(function (prop) {
        root.style.removeProperty(prop);
      });
    }

    function getDrawerFixedContainingBlock(drawer) {
      if (!drawer || !drawer.shadowRoot) {
        return null;
      }
      // Plus proche du cross-sell (light DOM sloté) en premier : body, puis content.
      var body = drawer.shadowRoot.querySelector('[part="body"]');
      var content = drawer.shadowRoot.querySelector('[part="content"]');
      if (body && getComputedStyle(body).transform !== 'none') {
        return body;
      }
      if (content && getComputedStyle(content).transform !== 'none') {
        return content;
      }
      return null;
    }

    function syncDesktopCrossSellAnchor(root) {
      if (!root || !isDrawerInlineCrossSell(root)) {
        return;
      }
      if (isMobileDrawerLayout() || root.hidden || root.classList.contains('is-ship-from-store')) {
        clearDesktopCrossSellAnchor(root);
        return;
      }
      var drawer = root.closest('cart-drawer');
      var content = drawer && drawer.shadowRoot && drawer.shadowRoot.querySelector('[part="content"]');
      if (!content || !isCartDrawerOpen(drawer)) {
        clearDesktopCrossSellAnchor(root);
        return;
      }
      var contentRect = content.getBoundingClientRect();
      if (contentRect.width < 1 || contentRect.height < 1) {
        clearDesktopCrossSellAnchor(root);
        return;
      }

      root.style.position = 'fixed';
      root.style.right = 'auto';
      root.style.width = DESKTOP_CROSS_SELL_WIDTH + 'px';
      root.scrollTop = 0;

      var containingBlock = getDrawerFixedContainingBlock(drawer);
      if (containingBlock) {
        var cbRect = containingBlock.getBoundingClientRect();
        root.style.top = Math.round(contentRect.top - cbRect.top) + 'px';
        root.style.height = Math.round(contentRect.height) + 'px';
        root.style.bottom = 'auto';
        root.style.left =
          Math.round(contentRect.left - cbRect.left - DESKTOP_CROSS_SELL_WIDTH) + 'px';
        return;
      }

      // Containing-block = viewport : coords viewport.
      root.style.top = Math.round(contentRect.top) + 'px';
      root.style.bottom = Math.round(window.innerHeight - contentRect.bottom) + 'px';
      root.style.left = Math.round(contentRect.left - DESKTOP_CROSS_SELL_WIDTH) + 'px';
      root.style.height = 'auto';
    }

    function scheduleDesktopCrossSellAnchor(root) {
      if (!root) {
        return;
      }
      if (desktopCrossSellAnchorRaf) {
        cancelAnimationFrame(desktopCrossSellAnchorRaf);
      }
      desktopCrossSellAnchorRaf = requestAnimationFrame(function () {
        desktopCrossSellAnchorRaf = requestAnimationFrame(function () {
          desktopCrossSellAnchorRaf = 0;
          syncDesktopCrossSellAnchor(root);
          // Resync après l'animation d'ouverture du drawer (transform settled).
          window.setTimeout(function () {
            syncDesktopCrossSellAnchor(root);
          }, 320);
        });
      });
    }

    function getMobileItemsAvailableHeight() {
      var body = getCartDrawerBodyEl();
      var drawer = document.querySelector('cart-drawer');
      if (!body || !drawer) {
        return 0;
      }
      var complementary = drawer.querySelector('.cart-drawer__complementary-products');
      var complementaryHeight = complementary ? complementary.offsetHeight : 0;
      return Math.max(0, body.clientHeight - complementaryHeight);
    }

    function setDrawerPinnedState(root, pinned) {
      var drawer = root && root.closest('cart-drawer');
      if (drawer) {
        drawer.classList.toggle('is-cross-sell-pinned', !!pinned);
      }
    }

    function isOverflowingVertically(el) {
      return !!el && el.scrollHeight > el.clientHeight + 1;
    }

    // Scroll activé uniquement si la hauteur du contenu dépasse la hauteur visible.
    function syncMobileDrawerScrollbars(root) {
      var drawer = root && root.closest('cart-drawer');
      var items = root && root.closest('.cart-drawer__items');
      var lines = items && items.querySelector('.cart-drawer__lines');
      var body = getCartDrawerBodyEl();
      if (!drawer || !items || !lines) {
        return;
      }

      var pinned = items.classList.contains('is-cross-sell-pinned');
      lines.classList.toggle('is-scrollable', pinned && isOverflowingVertically(lines));
      drawer.classList.toggle('is-body-scrollable', !pinned && isOverflowingVertically(body));
    }

    // Cross-sell masqué ou absent : le body défile seulement si son contenu dépasse.
    function syncMobileBodyScrollOnly() {
      var drawer = document.querySelector('cart-drawer');
      var body = getCartDrawerBodyEl();
      if (!drawer || !body) {
        return;
      }
      if (!isMobileDrawerLayout()) {
        drawer.classList.remove('is-body-scrollable');
        return;
      }
      drawer.classList.toggle('is-body-scrollable', isOverflowingVertically(body));
    }

    function clearMobileDrawerScrollbars(root) {
      var items = root && root.closest('.cart-drawer__items');
      var lines = items && items.querySelector('.cart-drawer__lines');
      if (lines) {
        lines.classList.remove('is-scrollable');
      }
      requestAnimationFrame(syncMobileBodyScrollOnly);
    }

    function clearMobileCrossSellLayout(root) {
      setDrawerPinnedState(root, false);
      clearMobileDrawerScrollbars(root);
      var items = root && root.closest('.cart-drawer__items');
      if (!items) {
        return;
      }
      items.classList.remove('is-cross-sell-pinned', 'is-cross-sell-flow');
      items.style.removeProperty('--cart-drawer-items-min-height');
    }

    function syncMobileCrossSellLayout(root) {
      if (!isMobileDrawerLayout() || !isDrawerInlineCrossSell(root) || root.hidden) {
        clearMobileCrossSellLayout(root);
        return;
      }

      var items = root.closest('.cart-drawer__items');
      var lines = items && items.querySelector('.cart-drawer__lines');
      if (!items || !lines) {
        return;
      }

      items.classList.remove('is-cross-sell-pinned');
      items.classList.add('is-cross-sell-flow');
      items.style.removeProperty('--cart-drawer-items-min-height');
      setDrawerPinnedState(root, false);

      var available = getMobileItemsAvailableHeight();
      var linesHeight = lines.offsetHeight;
      var crossSellHeight = root.offsetHeight;

      if (available > 0 && linesHeight + crossSellHeight <= available) {
        items.classList.remove('is-cross-sell-flow');
        items.classList.add('is-cross-sell-pinned');
        items.style.setProperty('--cart-drawer-items-min-height', available + 'px');
        setDrawerPinnedState(root, true);
      }

      requestAnimationFrame(function () {
        syncMobileDrawerScrollbars(root);
      });
    }

    function scheduleMobileCrossSellLayoutSync(root) {
      if (!root) {
        return;
      }
      if (mobileCrossSellLayoutRaf) {
        cancelAnimationFrame(mobileCrossSellLayoutRaf);
      }
      mobileCrossSellLayoutRaf = requestAnimationFrame(function () {
        mobileCrossSellLayoutRaf = requestAnimationFrame(function () {
          mobileCrossSellLayoutRaf = 0;
          syncMobileCrossSellLayout(root);
        });
      });
    }

    function ensureMobileCrossSellLayoutObserver() {
      if (mobileCrossSellLayoutObserver || typeof ResizeObserver === 'undefined') {
        return;
      }
      mobileCrossSellLayoutObserver = new ResizeObserver(function () {
        if (!isMobileDrawerLayout()) {
          return;
        }
        var root = getDrawerCrossSellRoot();
        if (root) {
          syncMobileCrossSellLayout(root);
        }
      });
    }

    function watchMobileCrossSellLayout(root) {
      if (!isMobileDrawerLayout() || !isDrawerInlineCrossSell(root)) {
        return;
      }
      ensureMobileCrossSellLayoutObserver();
      if (!mobileCrossSellLayoutObserver) {
        return;
      }
      var items = root.closest('.cart-drawer__items');
      var lines = items && items.querySelector('.cart-drawer__lines');
      var body = getCartDrawerBodyEl();
      var drawer = document.querySelector('cart-drawer');
      var complementary = drawer && drawer.querySelector('.cart-drawer__complementary-products');
      [body, items, lines, root, complementary].forEach(function (node) {
        if (node) {
          mobileCrossSellLayoutObserver.observe(node);
        }
      });
    }

    function preserveCrossSellBeforeDrawerRefresh() {
      var drawer = document.querySelector('cart-drawer');
      if (!drawer) {
        return;
      }
      var existing = drawer.querySelector('.cross-sell--drawer-items');
      if (!existing) {
        preservedDrawerCrossSell = null;
        return;
      }
      if (existing.closest('.cart-drawer__items--cross-sell-boot')) {
        preservedDrawerCrossSell = null;
        return;
      }
      preservedDrawerCrossSell = existing;
      preservedDrawerCrossSellVisible = !existing.hidden && proposalsListHasItems(existing);
      var body = getCartDrawerBodyEl();
      preservedDrawerBodyScrollTop = body ? body.scrollTop : 0;
    }

    function syncPreservedCrossSellEngineData(preserved, fresh) {
      if (!preserved || !fresh) {
        return;
      }
      var freshEngine = fresh.querySelector('.cross-sell__engine-data');
      var preservedEngine = preserved.querySelector('.cross-sell__engine-data');
      if (freshEngine && preservedEngine) {
        preservedEngine.textContent = freshEngine.textContent;
      }
      var freshStrings = fresh.querySelector('.cross-sell__strings');
      var preservedStrings = preserved.querySelector('.cross-sell__strings');
      if (freshStrings && preservedStrings) {
        preservedStrings.innerHTML = freshStrings.innerHTML;
      }
    }

    function ensureCrossSellVisibleIfHasProposals(root) {
      if (!root || !proposalsListHasItems(root)) {
        return;
      }
      var listEl = root.querySelector('.cross-sell__proposals .cross-sell__nested-list');
      if (listEl) {
        listEl.hidden = false;
      }
      setCrossSellVisibility(root, true);
      bindAddToCart(root);
    }

    function restoreCrossSellAfterDrawerRefresh() {
      if (!preservedDrawerCrossSell) {
        return null;
      }
      var drawer = document.querySelector('cart-drawer');
      var items = drawer && drawer.querySelector('.cart-drawer__items');
      // Ne jamais réinjecter dans le boot panier vide : ça fausse l'ancre au réajout.
      if (!items || items.classList.contains('cart-drawer__items--cross-sell-boot')) {
        preservedDrawerCrossSell = null;
        return null;
      }
      var freshCrossSell = items.querySelector('.cross-sell--drawer-items');
      if (freshCrossSell && freshCrossSell !== preservedDrawerCrossSell) {
        syncPreservedCrossSellEngineData(preservedDrawerCrossSell, freshCrossSell);
        freshCrossSell.replaceWith(preservedDrawerCrossSell);
      } else if (!items.contains(preservedDrawerCrossSell)) {
        items.appendChild(preservedDrawerCrossSell);
      }
      if (preservedDrawerCrossSellVisible) {
        ensureCrossSellVisibleIfHasProposals(preservedDrawerCrossSell);
      }
      preservedDrawerCrossSell.removeAttribute('data-cross-sell-pending-key');
      var restored = preservedDrawerCrossSell;
      preservedDrawerCrossSell = null;
      var body = getCartDrawerBodyEl();
      if (body) {
        requestAnimationFrame(function () {
          body.scrollTop = preservedDrawerBodyScrollTop;
        });
      }
      scheduleDesktopCrossSellAnchor(restored);
      return restored;
    }

    function setProposalsPending(root, message, options) {
      options = normalizeInitOptions(options);
      var silent = options.silent;
      var keepList = silent && proposalsListHasItems(root);
      var statusEl = root.querySelector('.cross-sell__proposals-status');
      var listEl = root.querySelector('.cross-sell__nested-list');

      if (!keepList) {
        root.classList.remove('is-ship-from-store');
      }

      if (statusEl) {
        if (silent) {
          statusEl.hidden = true;
        } else {
          statusEl.textContent = message || 'Vérification des stocks…';
          statusEl.hidden = false;
        }
      }

      if (listEl && !keepList) {
        listEl.hidden = true;
        listEl.replaceChildren();
      }
    }

    function detectShipFromStore(cart) {
      var blockers = [];
      (cart || []).forEach(function (item) {
        var acolyt = itemAcolytQuantity(item);
        if (acolyt != null && acolyt < 1) {
          blockers.push({ item: item, acolyt: acolyt });
        }
      });
      return { shipFromStore: blockers.length > 0, items: blockers };
    }

    function setShipFromStoreUi(root, sfs) {
      if (!root) {
        return;
      }
      root.classList.toggle('is-ship-from-store', !!(sfs && sfs.shipFromStore));
    }

    function setCrossSellVisibility(root, visible) {
      if (!root) {
        return;
      }
      if (visible) {
        root.hidden = false;
        root.removeAttribute('hidden');
        root.setAttribute('aria-hidden', 'false');
        scheduleDesktopCrossSellAnchor(root);
        scheduleMobileCrossSellLayoutSync(root);
        watchMobileCrossSellLayout(root);
        return;
      }
      root.hidden = true;
      root.setAttribute('hidden', '');
      root.setAttribute('aria-hidden', 'true');
      clearDesktopCrossSellAnchor(root);
      clearMobileCrossSellLayout(root);
    }

    function aggregateInventory(variants) {
      var byName = {};
      var hasLocations = false;
      var total = 0;
      (variants || []).forEach(function (variant) {
        total += Number(variant.inventory_quantity) || 0;
        (variant.inventory || []).forEach(function (entry) {
          var name = entry.name || 'Emplacement';
          byName[name] = (byName[name] || 0) + (Number(entry.quantity) || 0);
          hasLocations = true;
        });
      });
      if (!hasLocations) {
        return { entries: [], total: total };
      }
      return {
        entries: Object.keys(byName).map(function (name) {
          return { name: name, quantity: byName[name] };
        }),
        total: total,
      };
    }

    function inventoryForProduct(catalog, productId, variantId) {
      var product = (catalog || []).filter(function (entry) {
        return String(entry.id) === String(productId);
      })[0];
      if (!product) {
        return { entries: [], total: null };
      }
      if (variantId) {
        var variant = (product.variants || []).filter(function (entry) {
          return String(entry.id) === String(variantId);
        })[0];
        if (variant) {
          return {
            entries: variant.inventory || [],
            total: variant.inventory_quantity,
          };
        }
      }
      return aggregateInventory(product.variants);
    }

    function isCrossSellDebugEnabled() {
      try {
        return new URLSearchParams(window.location.search).get('debug_cross') === '1';
      } catch (error) {
        return false;
      }
    }

    function applyCrossSellDebugGate() {
      var enabled = isCrossSellDebugEnabled();
      document.documentElement.classList.toggle('is-cross-sell-debug', enabled);
      document.querySelectorAll('.cross-sell__debug-open').forEach(function (btn) {
        btn.hidden = !enabled;
      });
      if (!enabled) {
        var debug = document.querySelector('.cross-sell-debug');
        if (debug) {
          if (debug.open) {
            debug.close();
          }
          debug.remove();
        }
        return false;
      }
      document.querySelectorAll('.cross-sell').forEach(function (root) {
        root.setAttribute('data-debug-stock', 'true');
      });
      return true;
    }

    function debugRoot() {
      return findDebugModalInSection();
    }

    var DEBUG_OPEN_KEY = 'cross-sell-debug-open';
    var ensureDebugModalPromise = null;
    var lastDebugPayload = null;
    var debugToggleBound = false;

    function isDebugOpen(debug) {
      return !!(debug && debug.open);
    }

    function syncDebugButtons(isOpen) {
      document.querySelectorAll('.cross-sell__debug-open').forEach(function (btn) {
        btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
      try {
        sessionStorage.setItem(DEBUG_OPEN_KEY, isOpen ? '1' : '0');
      } catch (error) {}
    }

    function isCartDrawerOpen(drawer) {
      drawer = drawer || document.getElementById('cart-drawer');
      return !!(drawer && (drawer.open || drawer.hasAttribute('open')));
    }

    function bindDebugDialog(debug) {
      if (!debug || debug.getAttribute('data-close-bound') === 'true') {
        return;
      }
      debug.setAttribute('data-close-bound', 'true');
      debug.addEventListener('close', function () {
        syncDebugButtons(false);
      });
      debug.addEventListener('click', function (event) {
        if (event.target === debug) {
          setDebugOpen(debug, false);
        }
      });
      debug.addEventListener('cancel', function (event) {
        event.preventDefault();
        setDebugOpen(debug, false);
      });
    }

    function openDebugModal(debug) {
      if (!debug || typeof debug.showModal !== 'function') {
        return false;
      }
      if (debug.open) {
        return true;
      }
      try {
        debug.showModal();
        return true;
      } catch (error) {
        try {
          debug.setAttribute('open', '');
          return true;
        } catch (fallbackError) {
          return false;
        }
      }
    }

    function setDebugOpen(debug, isOpen) {
      debug = debug || debugRoot();
      if (!debug) {
        return;
      }
      bindDebugDialog(debug);
      if (isOpen) {
        if (!openDebugModal(debug)) {
          syncDebugButtons(false);
          return;
        }
      } else if (debug.open) {
        debug.close();
      }
      syncDebugButtons(isDebugOpen(debug));
      if (isOpen) {
        refillDebugPanel();
      }
    }

    function restoreDebugOpen() {
      if (!isCrossSellDebugEnabled()) {
        return Promise.resolve();
      }
      return ensureDebugModal().then(function (debug) {
        bindDebugDialog(debug);
        if (!debug) {
          return;
        }
        var open = false;
        try {
          open = sessionStorage.getItem(DEBUG_OPEN_KEY) === '1';
        } catch (error) {}
        if (open && isCartDrawerOpen()) {
          setDebugOpen(debug, true);
        } else {
          if (debug.open) {
            debug.close();
          }
          syncDebugButtons(false);
        }
      });
    }

    function bindDebugDrawerOpen() {
      if (window.__crossSellDebugDrawerBound) {
        return;
      }
      window.__crossSellDebugDrawerBound = true;
      document.addEventListener(
        'dialog:after-show',
        function (event) {
          if (!isCrossSellDebugEnabled()) {
            return;
          }
          var target = event.target;
          if (target && target.id === 'cart-drawer') {
            restoreDebugOpen();
          }
        },
        true
      );
      document.addEventListener(
        'dialog:after-hide',
        function (event) {
          if (event.target && event.target.id === 'cart-drawer') {
            setDebugOpen(debugRoot(), false);
          }
        },
        true
      );
    }

    function bindDebugToggle() {
      if (debugToggleBound) {
        return;
      }
      debugToggleBound = true;
      document.addEventListener('click', function (event) {
        if (event.target.closest('.cross-sell__debug-open')) {
          event.preventDefault();
          if (!isCrossSellDebugEnabled()) {
            return;
          }
          ensureDebugModal().then(function (debug) {
            setDebugOpen(debug, true);
          });
          return;
        }
        if (event.target.closest('.cross-sell-debug__close')) {
          setDebugOpen(debugRoot(), false);
        }
      });
      ensureDebugModal().then(function (debug) {
        bindDebugDialog(debug);
      });
    }

    function renderDebugCart(debug, cart) {
      var box = debug.querySelector('.cross-sell__cart');
      if (!box) {
        return;
      }
      var emptyEl = box.querySelector('.cross-sell__cart-empty');
      var listEl = box.querySelector('.cross-sell__nested-list');
      cart = cart || [];
      if (!cart.length) {
        if (emptyEl) {
          emptyEl.hidden = false;
        }
        if (listEl) {
          listEl.hidden = true;
          listEl.replaceChildren();
        }
        return;
      }
      if (emptyEl) {
        emptyEl.hidden = true;
      }
      if (!listEl) {
        return;
      }
      listEl.hidden = false;
      var fragment = document.createDocumentFragment();
      cart.forEach(function (item) {
        var li = document.createElement('li');
        li.className = 'cross-sell__nested-item';
        if (item.variant_id) {
          li.setAttribute('data-variant-id', String(item.variant_id));
        }
        var body = document.createElement('div');
        body.className = 'cross-sell__nested-body';
        var heading = document.createElement('p');
        heading.className = 'cross-sell__nested-heading';
        heading.textContent = (item.title || '') + ' / ' + (item.sku || item.variant_id || '');
        var fields = document.createElement('dl');
        fields.className = 'cross-sell__fields';
        fields.appendChild(renderField('Type', item.type));
        fields.appendChild(renderField('Taille', displayList(item.sizes)));
        fields.appendChild(renderField('Matière', displayList(item.materials)));
        fields.appendChild(renderField('Coloris', displayList(item.colors)));
        fields.appendChild(
          renderField('Stock Liquid', formatInventory(item.inventory, item.inventory_quantity), 'cross-sell__stock')
        );
        fields.appendChild(
          renderField(
            'Stock API',
            item.inventory_api ? formatInventory(item.inventory_api) : '(pas encore chargé)',
            'cross-sell__stock-api'
          )
        );
        body.appendChild(heading);
        body.appendChild(fields);
        li.appendChild(body);
        fragment.appendChild(li);
      });
      listEl.replaceChildren(fragment);
    }

    function renderDebugCatalog(debug, catalog, meta) {
      var title = debug.querySelector('.cross-sell-debug__collection-title');
      var status = debug.querySelector('.cross-sell__collection-status');
      var list = debug.querySelector('.cross-sell__collection-products');
      meta = meta || {};
      catalog = catalog || [];
      if (title) {
        title.textContent = meta.missing
          ? 'Collection ' + (meta.id || '')
          : ['Collection', meta.id, meta.title, meta.handle].filter(Boolean).join(' / ');
      }
      if (status) {
        if (meta.missing) {
          status.textContent = 'Collection introuvable en vitrine.';
        } else {
          status.textContent =
            catalog.length +
            ' produits chargés (max 250).' +
            (meta.total > 250 ? ' ' + meta.total + ' au total dans la collection.' : '') +
            ' Seuls ces produits peuvent être proposés.';
        }
      }
      if (!list) {
        return;
      }
      list.replaceChildren();
      catalog.forEach(function (product) {
        var li = document.createElement('li');
        li.className = 'cross-sell__collection-product';
        var heading = document.createElement('p');
        heading.className = 'cross-sell__collection-product-heading';
        heading.textContent = [product.id, product.title, product.handle].filter(Boolean).join(' / ');
        var info = document.createElement('div');
        info.className = 'cross-sell__product-debug';
        var priceText =
          product.price_varies && product.price_min !== product.price_max
            ? product.price_min + ' – ' + product.price_max
            : product.price_min || '';
        var stock = aggregateInventory(product.variants);
        info.textContent =
          'Achetable : ' +
          (product.available ? 'oui' : 'non') +
          (priceText ? ' · Prix : ' + priceText : '') +
          ' · Handle : ' +
          (product.handle || '') +
          ' · Stock : ' +
          formatInventory(stock.entries, stock.total);
        li.appendChild(heading);
        li.appendChild(info);
        list.appendChild(li);
      });
    }

    function renderDebugRules(debug, rules, catalog) {
      var emptyEl = debug.querySelector('.cross-sell-debug__rules-empty');
      var titleEl = debug.querySelector('.cross-sell__block-title');
      var listEl = debug.querySelector('.cross-sell__list');
      rules = rules || [];
      if (emptyEl) {
        emptyEl.hidden = rules.length > 0;
      }
      if (titleEl) {
        titleEl.hidden = rules.length === 0;
      }
      if (!listEl) {
        return;
      }
      listEl.replaceChildren();
      var fragment = document.createDocumentFragment();
      rules.forEach(function (rule) {
        var li = document.createElement('li');
        li.className = 'cross-sell__entry cross-sell__item';
        li.setAttribute('data-handle', rule.handle || '');

        var title = document.createElement('p');
        title.className = 'cross-sell__item-title';
        title.appendChild(
          document.createTextNode(
            [rule.handle, 'bloc ' + (rule.bloc != null ? rule.bloc : '(vide)'), rule.mecanique || '(vide)'].join(
              ' · '
            ) + ' '
          )
        );
        var flag = document.createElement('span');
        flag.className = 'cross-sell__match-flag';
        flag.setAttribute('data-rule-handle', rule.handle || '');
        title.appendChild(flag);
        li.appendChild(title);

        var fields = document.createElement('dl');
        fields.className = 'cross-sell__fields';
        var productText = rule.product_id
          ? [rule.product_id, rule.title, rule.product_handle].filter(Boolean).join(' / ')
          : rule.gid || '(vide)';
        var productField = renderField('Produit', productText);
        var productNote = document.createElement('span');
        productNote.className = 'cross-sell__product-debug';
        productNote.textContent = rule.product_id
          ? 'Source : produit — la variante est choisie à l’exécution. Achetable produit : ' +
            (rule.product_available ? 'oui' : 'non') +
            (rule.product_handle ? ' · Handle : ' + rule.product_handle : '')
          : rule.gid
          ? 'Achetable / prix / handle : indisponible (hors vitrine)'
          : '';
        if (productNote.textContent) {
          productField.querySelector('dd').appendChild(document.createTextNode(' '));
          productField.querySelector('dd').appendChild(productNote);
        }
        fields.appendChild(productField);
        fields.appendChild(renderField('Exclusion Type', displayList(rule.exclusion_types)));
        fields.appendChild(renderField('Taille', displayList(rule.sizes)));
        fields.appendChild(renderField('Matière', displayList(rule.materials)));
        fields.appendChild(renderField('Coloris', displayList(rule.colors)));
        var stock = inventoryForProduct(catalog, rule.product_id, rule.variant_id);
        fields.appendChild(renderField('Stock', formatInventory(stock.entries, stock.total)));
        li.appendChild(fields);

        var why = document.createElement('div');
        why.className = 'cross-sell__rule-why';
        why.setAttribute('data-rule-handle', rule.handle || '');
        var whyTitle = document.createElement('p');
        whyTitle.className = 'cross-sell__rule-why-title';
        whyTitle.textContent = 'Pourquoi vs chaque produit du panier';
        var whyList = document.createElement('ul');
        whyList.className = 'cross-sell__rule-why-list';
        why.appendChild(whyTitle);
        why.appendChild(whyList);
        li.appendChild(why);
        fragment.appendChild(li);
      });
      listEl.appendChild(fragment);
    }

    function fillDebug(engine, results) {
      if (!isCrossSellDebugEnabled()) {
        return;
      }
      lastDebugPayload = { engine: engine, results: results || [] };
      var debug = debugRoot();
      if (!debug) {
        return;
      }
      renderShipFromStoreNotice(debug, engine);
      renderDebugApiStocks(debug, engine);
      renderDebugCart(debug, engine.cart);
      renderDebugCatalog(debug, engine.catalog, engine.catalogMeta);
      renderDebugRules(debug, engine.rules, engine.catalog);
      renderAlgo(debug, engine.cart, results, engine);
      renderRuleFlags(debug, results);
      renderRuleCartWhy(debug, engine.cart, results);
    }

    function refillDebugPanel() {
      if (!lastDebugPayload || !debugRoot()) {
        return;
      }
      fillDebug(lastDebugPayload.engine, lastDebugPayload.results);
    }

    function getCartDrawerSectionId() {
      var drawer = document.getElementById('cart-drawer');
      if (drawer && drawer.getAttribute('data-section-id')) {
        return drawer.getAttribute('data-section-id');
      }
      var crossSell = document.querySelector('cart-drawer .cross-sell--drawer-items');
      if (crossSell && crossSell.getAttribute('data-section-id')) {
        return crossSell.getAttribute('data-section-id');
      }
      var sectionEl = document.querySelector('.shopify-section--cart-drawer[id^="shopify-section-"]');
      if (sectionEl && sectionEl.id) {
        return sectionEl.id.replace('shopify-section-', '');
      }
      return '';
    }

    function getCrossSellDebugSectionId() {
      var debug = document.querySelector('.cross-sell-debug[data-section-id]');
      if (debug && debug.getAttribute('data-section-id')) {
        return debug.getAttribute('data-section-id');
      }
      var sectionEl = document.querySelector('.section-cross-sell-debug[id^="shopify-section-"]');
      if (sectionEl && sectionEl.id) {
        return sectionEl.id.replace('shopify-section-', '');
      }
      return 'cross-sell-debug';
    }

    function extractDebugFromSectionHtml(html) {
      if (!html) {
        return null;
      }
      var wrapper = document.createElement('div');
      wrapper.innerHTML = html.trim();
      return (
        wrapper.querySelector('.cross-sell-debug') ||
        wrapper.querySelector('cart-drawer + .cross-sell-debug') ||
        wrapper.querySelector('#shopify-section-' + getCartDrawerSectionId() + ' .cross-sell-debug')
      );
    }

    function findDebugModalInSection() {
      var debug = document.querySelector('.section-cross-sell-debug .cross-sell-debug');
      if (debug) {
        return debug;
      }
      var sectionId = getCrossSellDebugSectionId();
      if (sectionId) {
        var inSection = document.querySelector('#shopify-section-' + sectionId + ' .cross-sell-debug');
        if (inSection) {
          return inSection;
        }
      }
      return document.querySelector('.cross-sell-debug');
    }

    function attachDebugModalToBody(debugEl) {
      if (!debugEl) {
        return null;
      }
      if (debugEl.parentElement !== document.body) {
        document.body.appendChild(debugEl);
      }
      bindDebugDialog(debugEl);
      return debugEl;
    }

    function mountDebugModal(debugEl) {
      if (!debugEl) {
        return null;
      }
      var existing = debugRoot();
      if (existing) {
        return attachDebugModalToBody(existing);
      }
      return attachDebugModalToBody(debugEl);
    }

    function fetchDebugSectionHtml(sectionId) {
      if (!sectionId) {
        return Promise.resolve('');
      }
      var url = new URL(window.location.origin + window.location.pathname);
      url.searchParams.set('section_id', sectionId);
      url.searchParams.set('debug_cross', '1');
      if (window.location.search) {
        var pageParams = new URLSearchParams(window.location.search);
        pageParams.forEach(function (value, key) {
          if (key !== 'section_id') {
            url.searchParams.set(key, value);
          }
        });
      }
      return fetch(url.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } }).then(function (response) {
        if (!response.ok) {
          throw new Error('Rechargement impossible');
        }
        return response.text();
      });
    }

    function ensureDebugModal() {
      if (!isCrossSellDebugEnabled()) {
        return Promise.resolve(null);
      }
      var existing = debugRoot();
      if (existing) {
        return Promise.resolve(attachDebugModalToBody(existing));
      }
      if (ensureDebugModalPromise) {
        return ensureDebugModalPromise;
      }
      var sectionId = getCrossSellDebugSectionId() || getCartDrawerSectionId();
      if (!sectionId) {
        return Promise.resolve(null);
      }
      ensureDebugModalPromise = fetchDebugSectionHtml(sectionId)
        .then(function (html) {
          return mountDebugModal(extractDebugFromSectionHtml(html));
        })
        .catch(function () {
          return null;
        })
        .finally(function () {
          ensureDebugModalPromise = null;
        });
      return ensureDebugModalPromise;
    }

    function lookupStockLabel(engine, variantId) {
      var id = String(variantId);
      var label = '';
      (engine.cart || []).some(function (item) {
        if (String(item.variant_id) === id) {
          label = ['panier', item.title, item.sku].filter(Boolean).join(' · ');
          return true;
        }
        return false;
      });
      if (label) {
        return label;
      }
      (engine.catalog || []).some(function (product) {
        return (product.variants || []).some(function (variant) {
          if (String(variant.id) === id) {
            label = [product.title, variant.title, product.handle].filter(Boolean).join(' · ');
            return true;
          }
          return false;
        });
      });
      return label || 'variante ' + id;
    }

    function renderDebugApiStocks(debug, engine) {
      var box = debug.querySelector('.cross-sell__api-stocks');
      if (!box) {
        return;
      }
      var statusEl = box.querySelector('.cross-sell__api-stocks-status');
      var listEl = box.querySelector('.cross-sell__api-stocks-list');
      var stock = (engine && engine.apiStock) || { byId: {}, ids: [], error: '', fetched: false };
      var ids = stock.ids || [];
      if (statusEl) {
        if (stock.error) {
          statusEl.textContent = 'Appel API en échec (' + stock.error + '). Ship from Store non appliqué.';
        } else if (!ids.length) {
          statusEl.textContent = 'Aucun variant_id panier (panier vide).';
        } else if (!stock.fetched) {
          statusEl.textContent = 'En attente de /apps/rivecour-stock-boutique…';
        } else {
          statusEl.textContent =
            '1 POST /apps/rivecour-stock-boutique · ' +
            ids.length +
            ' variante panier' +
            (ids.length > 1 ? 's' : '') +
            ' · ' +
            Object.keys(stock.byId || {}).length +
            ' réponse' +
            (Object.keys(stock.byId || {}).length > 1 ? 's' : '') +
            '. SFS = Acolyt < 1 sur au moins une ligne panier.';
        }
      }
      if (!listEl) {
        return;
      }
      listEl.replaceChildren();
      ids.forEach(function (variantId) {
        var row = (stock.byId || {})[String(variantId)];
        var li = document.createElement('li');
        li.className = 'cross-sell__api-stocks-item';
        var heading = document.createElement('p');
        heading.className = 'cross-sell__nested-heading';
        heading.textContent = lookupStockLabel(engine, variantId) + ' · ' + String(variantId);
        var detail = document.createElement('p');
        detail.className = 'cross-sell__product-debug';
        if (!row) {
          detail.textContent = 'Pas de réponse API pour cette variante.';
        } else {
          detail.textContent =
            formatInventory(inventoryEntriesFromApi(row)) +
            (row.is_cached ? ' · cache app' : ' · frais') +
            (row.stock != null && row.stock !== '' ? ' · stock app : ' + String(row.stock) : '');
        }
        li.appendChild(heading);
        li.appendChild(detail);
        listEl.appendChild(li);
      });
    }

    function renderShipFromStoreNotice(debug, engine) {
      var panel = debug.querySelector('.cross-sell-debug__panel');
      if (!panel) {
        return;
      }
      var existing = panel.querySelector('.cross-sell__sfs-notice');
      if (existing) {
        existing.remove();
      }
      if (!engine || !engine.shipFromStore) {
        return;
      }
      var notice = document.createElement('p');
      notice.className = 'cross-sell__sfs-notice';
      var names = (engine.shipFromStoreItems || [])
        .map(function (row) {
          return (row.item.title || row.item.sku || row.item.variant_id) + ' · Acolyt : ' + row.acolyt;
        })
        .join(' · ');
      notice.textContent =
        'Suggestions masquées : panier Ship from Store (Acolyt < 1 sur au moins une ligne panier). ' + names;
      panel.insertBefore(notice, panel.firstChild);
    }

    function renderProposals(root, results, sfs, options) {
      options = normalizeInitOptions(options);
      var silent = options.silent;
      var box = root.querySelector('.cross-sell__proposals');
      if (!box) {
        return;
      }

      var statusEl = box.querySelector('.cross-sell__proposals-status');
      var listEl = box.querySelector('.cross-sell__nested-list');
      var keepVisible = silent && !root.hidden && proposalsListHasItems(root);
      setShipFromStoreUi(root, sfs);

      if (sfs && sfs.shipFromStore) {
        if (statusEl) {
          statusEl.textContent = '';
          statusEl.hidden = true;
        }
        if (listEl) {
          listEl.hidden = true;
          listEl.replaceChildren();
        }
        setCrossSellVisibility(root, false);
        clearMobileCrossSellLayout(root);
        return;
      }

      var proposed = results
        .filter(function (result) {
          return result.proposed;
        })
        .sort(function (a, b) {
          var blocDelta = blocKey(a.rule) - blocKey(b.rule);
          if (blocDelta) {
            return blocDelta;
          }
          return (a.assignedOrder || 0) - (b.assignedOrder || 0);
        });

      if (!proposed.length) {
        if (statusEl) {
          statusEl.textContent = '';
          statusEl.hidden = true;
        }
        if (listEl) {
          listEl.hidden = true;
          listEl.replaceChildren();
        }
        setCrossSellVisibility(root, false);
        clearMobileCrossSellLayout(root);
        return;
      }

      if (statusEl) {
        statusEl.textContent = '';
        statusEl.hidden = true;
      }
      if (listEl) {
        listEl.hidden = false;
      }
      if (!keepVisible) {
        setCrossSellVisibility(root, true);
      }

      var urls = proposed
        .map(function (result) {
          return thumbUrlForLayout(result.rule.image);
        })
        .filter(Boolean);
      var missingUrls = urls.filter(function (url) {
        return !thumbCache.isReady(url);
      });

      function paint() {
        renderProposalsDom(listEl, proposed, root);
        if (keepVisible || proposed.length) {
          setCrossSellVisibility(root, true);
        }
        scheduleMobileCrossSellLayoutSync(root);
        watchMobileCrossSellLayout(root);
      }

      if (proposalsListHasItems(root)) {
        paint();
        if (missingUrls.length) {
          thumbCache.preloadMany(missingUrls).then(paint);
        } else {
          thumbCache.preloadMany(urls);
        }
      } else if (!missingUrls.length) {
        paint();
        thumbCache.preloadMany(urls);
      } else {
        thumbCache.preloadMany(urls).then(paint);
      }
    }

    function shopifyRoot() {
      return window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
    }

    function bindAddToCart(root) {
      var box = root.querySelector('.cross-sell__proposals');
      if (!box || box.getAttribute('data-add-bound') === 'true') {
        return;
      }

      box.setAttribute('data-add-bound', 'true');

      function resolveAddButton(event) {
        var item = event.target.closest('.cross-sell__nested-item');
        if (!item || !box.contains(item)) {
          return null;
        }
        var addButton = event.target.closest('.cross-sell__add');
        if (addButton) {
          return addButton;
        }
        var thumb = event.target.closest('.cross-sell__thumb');
        if (thumb && item.contains(thumb)) {
          return item.querySelector('.cross-sell__add');
        }
        return null;
      }

      function triggerAdd(event) {
        var button = resolveAddButton(event);
        if (!button || button.disabled) {
          return;
        }

        var variantId = Number(button.getAttribute('data-variant-id'));
        if (!variantId) {
          return;
        }

        event.preventDefault();
        addToCart(root, button, variantId);
      }

      box.addEventListener('click', triggerAdd);
      box.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') {
          return;
        }
        if (!event.target.closest('.cross-sell__thumb.is-addable')) {
          return;
        }
        event.preventDefault();
        triggerAdd(event);
      });
    }

    function cartHasVariant(cart, variantId) {
      return (cart.items || []).some(function (item) {
        return String(item.variant_id) === String(variantId);
      });
    }

    function waitForCartVariant(variantId, attempt) {
      attempt = attempt || 0;
      return fetch(shopifyRoot() + 'cart.js', {
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          if (cartHasVariant(cart, variantId) || attempt >= 5) {
            if (!cartHasVariant(cart, variantId)) {
              throw new Error('Ajout non confirmé dans le panier');
            }
            return cart;
          }
          return new Promise(function (resolve, reject) {
            setTimeout(function () {
              waitForCartVariant(variantId, attempt + 1).then(resolve, reject);
            }, 200);
          });
        });
    }

    function innerFromIncoming(incoming, selector) {
      if (!incoming) {
        return null;
      }
      if (incoming.matches && incoming.matches(selector)) {
        return incoming;
      }
      return incoming.querySelector(selector);
    }

    function replaceSectionEl(currentInner, html, selector) {
      if (!currentInner || !html) {
        return currentInner;
      }
      var wrapper = document.createElement('div');
      wrapper.innerHTML = html.trim();
      var incoming = wrapper.querySelector(selector) || wrapper.firstElementChild;
      if (!incoming) {
        throw new Error('Rechargement impossible');
      }
      currentInner.replaceWith(incoming);
      return innerFromIncoming(incoming, selector);
    }

    function fetchSectionHtml(sectionId) {
      if (!sectionId) {
        return Promise.resolve('');
      }
      var url = new URL(window.location.href);
      url.searchParams.set('section_id', sectionId);
      return fetch(url.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } }).then(function (response) {
        if (!response.ok) {
          throw new Error('Rechargement impossible');
        }
        return response.text();
      });
    }

    function htmlForSection(sections, sectionId) {
      if (sectionId && sections && sections[sectionId]) {
        return Promise.resolve(sections[sectionId]);
      }
      return fetchSectionHtml(sectionId);
    }

    function reloadDebug(sections) {
      if (!isCrossSellDebugEnabled()) {
        return Promise.resolve();
      }

      return ensureDebugModal().then(function (debug) {
        if (!debug) {
          return;
        }
        var debugId = debug.getAttribute('data-section-id');
        if (!debugId) {
          return;
        }

        return htmlForSection(sections || {}, debugId)
          .then(function (debugHtml) {
            if (!debugHtml) {
              return;
            }
            var currentDebug = debugRoot() || debug;
            if (currentDebug) {
              replaceSectionEl(currentDebug, debugHtml, '.cross-sell-debug');
            }
            refillDebugPanel();
            return restoreDebugOpen();
          })
          .catch(function () {});
      });
    }

    function reloadAfterCartChange(root, sections) {
      sections = sections || {};
      var insideDrawer = !!(root && root.closest('cart-drawer'));
      var debugPromise = reloadDebug(sections);

      if (insideDrawer) {
        return debugPromise;
      }

      var proposalId = root.getAttribute('data-section-id');
      return htmlForSection(sections, proposalId)
        .then(function (proposalHtml) {
          var nextRoot = proposalHtml ? replaceSectionEl(root, proposalHtml, '.cross-sell') : root;
          return debugPromise.then(function () {
            if (nextRoot) {
              initEngine(nextRoot, { silent: true });
            }
            restoreDebugOpen();
          });
        })
        .catch(function () {
          window.location.reload();
        });
    }

    function reloadCrossSell(root, sectionHtml) {
      var sections = {};
      var sectionId = root.getAttribute('data-section-id');
      if (sectionHtml && sectionId) {
        sections[sectionId] = sectionHtml;
      }
      reloadAfterCartChange(root, sections);
    }

    function addToCart(root, button, variantId) {
      var box = root.querySelector('.cross-sell__proposals');
      var addUrl = (box && box.getAttribute('data-cart-add-url')) || shopifyRoot() + 'cart/add.js';
      var sectionId = root.getAttribute('data-section-id');
      var sectionsToBundle = [];

      document.documentElement.dispatchEvent(
        new CustomEvent('cart:prepare-bundled-sections', {
          bubbles: true,
          detail: { sections: sectionsToBundle },
        })
      );
      if (sectionId && sectionsToBundle.indexOf(sectionId) === -1) {
        sectionsToBundle.push(sectionId);
      }

      button.disabled = true;
      button.setAttribute('aria-busy', 'true');

      fetch(addUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
          sections: sectionsToBundle.join(','),
          sections_url: window.location.pathname + window.location.search,
        }),
      })
        .then(function (response) {
          return response.json().then(function (json) {
            if (!response.ok) {
              throw new Error(json.description || json.message || 'Ajout impossible');
            }
            return json;
          });
        })
        .then(function (addJson) {
          return waitForCartVariant(variantId).then(function (cart) {
            cart.sections = addJson.sections || {};
            return cart;
          });
        })
        .then(function (cart) {
          button.disabled = false;
          button.removeAttribute('aria-busy');
          document.documentElement.dispatchEvent(
            new CustomEvent('cart:change', {
              bubbles: true,
              detail: { cart: cart, baseEvent: 'variant:add' },
            })
          );
        })
        .catch(function (error) {
          button.disabled = false;
          button.removeAttribute('aria-busy');
          window.alert(error.message || 'Ajout au panier impossible.');
        });
    }

    function renderRuleCartWhy(root, cart, results) {
      cart = cart || [];
      (results || []).forEach(function (result) {
        var box = root.querySelector('.cross-sell__rule-why[data-rule-handle="' + result.rule.handle + '"]');
        if (!box) {
          return;
        }

        var list = box.querySelector('.cross-sell__rule-why-list');
        if (!list) {
          return;
        }
        list.replaceChildren();

        if (!cart.length) {
          var empty = document.createElement('li');
          empty.textContent = 'Panier vide : aucun produit à tester.';
          list.appendChild(empty);
          return;
        }

        cart.forEach(function (item, index) {
          var detail = itemQualifyDetail(item, result.rule);
          var li = document.createElement('li');
          li.className = detail.ok ? 'is-ok' : 'is-no';
          li.textContent =
            lineLabel(item, index) +
            ' — ' +
            (detail.ok ? 'OK' : 'non') +
            ' · ' +
            (detail.checks && detail.checks.length ? detail.checks.join(' · ') : detail.reason);
          list.appendChild(li);
        });

        if (result.matches.length && !result.proposed) {
          var extra = document.createElement('li');
          extra.className = 'is-no';
          if (result.alreadyInCart) {
            extra.textContent = 'Ligne(s) OK, mais produit déjà au panier.';
          } else if (!result.inCatalog) {
            extra.textContent = 'Ligne(s) OK, mais produit hors collection.';
          } else if (result.rule.variant_fail === 'size') {
            extra.textContent = 'Ligne(s) OK, mais aucune variante à la bonne taille.';
          } else if (!result.rule.available) {
            extra.textContent = 'Ligne(s) OK, mais aucune variante achetable.';
          } else if (result.superseded) {
            extra.textContent =
              'Ligne(s) OK, mais ' +
              (result.supersedeReason || 'un autre produit du même bloc a été choisi pour ce produit du panier.');
          }
          if (extra.textContent) {
            list.appendChild(extra);
          }
        }
      });
    }

    function renderRuleFlags(root, results) {
      results.forEach(function (result) {
        var flag = root.querySelector('.cross-sell__match-flag[data-rule-handle="' + result.rule.handle + '"]');
        if (!flag) {
          return;
        }
        flag.classList.remove('is-yes', 'is-no', 'is-maybe');
        if (result.proposed) {
          flag.classList.add('is-yes');
          flag.textContent = 'proposé';
        } else if (result.alreadyInCart) {
          flag.classList.add('is-no');
          flag.textContent = 'déjà au panier';
        } else if (result.matches.length && !result.inCatalog) {
          flag.classList.add('is-no');
          flag.textContent = 'hors collection';
        } else if (result.matches.length && result.rule.variant_fail === 'size') {
          flag.classList.add('is-no');
          flag.textContent = 'pas de taille';
        } else if (result.matches.length && !result.rule.available) {
          flag.classList.add('is-no');
          flag.textContent = 'non achetable';
        } else if (result.superseded) {
          flag.classList.add('is-maybe');
          flag.textContent =
            result.supersedeReason && result.supersedeReason.indexOf('doublon') === 0
              ? 'match · doublon'
              : 'match · autre du même bloc / produit';
        } else {
          flag.classList.add('is-no');
          flag.textContent = 'non';
        }
      });
    }

    function renderAlgo(root, cart, results, engine) {
      var box = root.querySelector('.cross-sell__algo-trace');
      if (!box) {
        return;
      }

      cart = cart || [];
      results = results || [];
      box.replaceChildren();

      if (engine && engine.shipFromStore) {
        var sfs = document.createElement('p');
        sfs.textContent =
          'Panier Ship from Store : suggestions masquées (Acolyt < 1 sur au moins une ligne panier, pas les produits proposés).';
        box.appendChild(sfs);
      }

      if (!cart.length) {
        var empty = document.createElement('p');
        empty.textContent = 'Panier vide : aucune ligne à tester, aucune proposition.';
        box.appendChild(empty);
        return;
      }

      var typeGroups = {};
      cart.forEach(function (item, index) {
        var type = item.type || '(sans type)';
        if (!typeGroups[type]) {
          typeGroups[type] = [];
        }
        typeGroups[type].push({ item: item, index: index });
      });

      var summary = document.createElement('p');
      summary.textContent =
        cart.length +
        ' ligne' +
        (cart.length > 1 ? 's' : '') +
        ' · ' +
        Object.keys(typeGroups).length +
        ' type' +
        (Object.keys(typeGroups).length > 1 ? 's' : '') +
        ' produit. Chaque ligne est un test indépendant.';
      box.appendChild(summary);

      var groupBox = document.createElement('div');
      groupBox.className = 'cross-sell__algo-group';
      var groupTitle = document.createElement('p');
      groupTitle.className = 'cross-sell__algo-group-title';
      groupTitle.textContent = 'Lignes par type produit';
      var groupList = document.createElement('ul');
      groupList.className = 'cross-sell__algo-list';
      Object.keys(typeGroups).forEach(function (type) {
        var entries = typeGroups[type];
        var li = document.createElement('li');
        var triggering = entries.filter(function (entry) {
          return results.some(function (result) {
            return result.matches.indexOf(entry.item) !== -1;
          });
        });
        li.textContent =
          type +
          ' — ' +
          entries.length +
          ' ligne' +
          (entries.length > 1 ? 's' : '') +
          ' : ' +
          entries
            .map(function (entry) {
              return lineLabel(entry.item, entry.index);
            })
            .join(' · ') +
          (triggering.length
            ? ' → ' + triggering.length + ' déclenche au moins une règle'
            : ' → aucune règle déclenchée');
        groupList.appendChild(li);
      });
      groupBox.appendChild(groupTitle);
      groupBox.appendChild(groupList);
      box.appendChild(groupBox);

      var byBloc = {};
      results.forEach(function (result) {
        if (!result.matches.length && !result.proposed) {
          return;
        }
        var key = String(blocKey(result.rule));
        if (!byBloc[key]) {
          byBloc[key] = [];
        }
        byBloc[key].push(result);
      });

      var blocKeys = Object.keys(byBloc).sort(function (a, b) {
        return Number(a) - Number(b);
      });

      if (!blocKeys.length) {
        var none = document.createElement('p');
        none.textContent =
          'Aucune règle n’a matché une ligne (exclusion de type, critères ET sur la même ligne, ou règle sans critère positif).';
        box.appendChild(none);
        return;
      }

      blocKeys.forEach(function (key) {
        var blocResults = byBloc[key].slice().sort(function (a, b) {
          function rank(result) {
            if (result.proposed) {
              return 0;
            }
            if (result.superseded) {
              return 1;
            }
            if (result.alreadyInCart) {
              return 2;
            }
            if (!result.inCatalog) {
              return 3;
            }
            if (result.rule.variant_fail === 'size') {
              return 4;
            }
            if (!result.rule.available) {
              return 5;
            }
            return 6;
          }
          var delta = rank(a) - rank(b);
          if (delta) {
            return delta;
          }
          return compareCandidates(a, b);
        });
        var blocBox = document.createElement('div');
        blocBox.className = 'cross-sell__algo-bloc';
        var title = document.createElement('p');
        title.className = 'cross-sell__algo-bloc-title';
        title.textContent = 'Bloc ' + key + ' — 1 produit max par produit du panier';
        var list = document.createElement('ol');
        list.className = 'cross-sell__algo-list';

        var winners = blocResults.filter(function (result) {
          return result.proposed;
        });

        blocResults.forEach(function (result) {
          var li = document.createElement('li');
          var itemIndexes = result.matches
            .map(function (item) {
              return cart.indexOf(item);
            })
            .filter(function (index) {
              return index !== -1;
            });
          var triggerText = itemIndexes.length
            ? 'déclenché par ' +
              itemIndexes
                .map(function (index) {
                  return lineLabel(cart[index], index);
                })
                .join(' | ')
            : 'aucun déclencheur';
          var skipped = cart
            .map(function (item, index) {
              if (result.matches.indexOf(item) !== -1) {
                return null;
              }
              var detail = itemQualifyDetail(item, result.rule);
              return lineLabel(item, index) + ' : ' + detail.reason;
            })
            .filter(Boolean);

          var status;
          var winnerForResult =
            (winners || []).filter(function (entry) {
              return result.assignedKey && entry.assignedKey === result.assignedKey;
            })[0] || winners[0];
          if (result.proposed) {
            status =
              'PROPOSÉ' +
              (result.assignedItems && result.assignedItems.length
                ? ' pour ' +
                  result.assignedItems
                    .map(function (item) {
                      return lineLabel(item, cart.indexOf(item));
                    })
                    .join(' | ')
                : '');
          } else if (result.alreadyInCart) {
            status = 'écarté : déjà au panier';
          } else if (!result.inCatalog) {
            status = 'écarté : hors collection';
          } else if (result.rule.variant_fail === 'size') {
            status = 'écarté : aucune variante à la bonne taille';
          } else if (!result.rule.available) {
            status = 'écarté : aucune variante achetable';
          } else if (result.supersedeReason) {
            status = 'écarté : ' + result.supersedeReason;
          } else if (result.superseded && winnerForResult) {
            status = 'écarté : autre du même bloc / produit (' + compareReason(winnerForResult, result) + ')';
          } else if (result.superseded) {
            status = 'écarté : autre du même bloc / produit';
          } else {
            status = 'non retenu';
          }

          var text = document.createElement('p');
          text.textContent =
            ruleLabel(result.rule) +
            ' — ' +
            status +
            ' — ' +
            triggerText +
            (result.rule.variant_id
              ? ' — variante ' +
                (result.rule.variant_title || result.rule.variant_id) +
                ' · ' +
                String(result.rule.variant_score || 0) +
                ' pt' +
                ((result.rule.variant_score_parts || []).length
                  ? ' (' + result.rule.variant_score_parts.join(', ') + ')'
                  : '') +
                ' · achetable'
              : ' — ' + variantFailLabel(result.rule.variant_fail)) +
            ' — précision ' +
            ruleSpecificity(result.rule);
          li.appendChild(text);

          if (skipped.length && skipped.length <= cart.length) {
            var skipList = document.createElement('ul');
            skipList.className = 'cross-sell__algo-list';
            skipped.forEach(function (line) {
              var skipItem = document.createElement('li');
              skipItem.textContent = line;
              skipList.appendChild(skipItem);
            });
            li.appendChild(skipList);
          }

          list.appendChild(li);
        });

        blocBox.appendChild(title);
        blocBox.appendChild(list);
        box.appendChild(blocBox);
      });
    }

    function initEngine(root, options) {
      if (!root) {
        return Promise.resolve(null);
      }
      return runEnginePipeline(root, readEngine(root), normalizeInitOptions(options));
    }

    var cartListenersBound = false;

    function bindCartListeners() {
      if (cartListenersBound) {
        return;
      }
      cartListenersBound = true;

      document.addEventListener('cart:change', onCartChangeForCrossSell);
      document.addEventListener('cart:change', preserveCrossSellBeforeDrawerRefresh, true);
      document.addEventListener('cart:refresh', preserveCrossSellBeforeDrawerRefresh, true);

      document.addEventListener(
        'dialog:after-show',
        function (event) {
          if (!event.target || event.target.id !== 'cart-drawer') {
            return;
          }
          var root = getDrawerCrossSellRoot(event.target);
          if (root) {
            scheduleDesktopCrossSellAnchor(root);
            if (isMobileDrawerLayout()) {
              scheduleMobileCrossSellLayoutSync(root);
            }
          } else if (isMobileDrawerLayout()) {
            requestAnimationFrame(syncMobileBodyScrollOnly);
          }
        },
        true
      );

      // Réinsère le nœud cross-sell préservé avant le refresh du drawer.
      // Après replaceChildren : sync engine-data serveur, puis refresh silencieux.
      window.addEventListener('resize', function () {
        document.querySelectorAll('.cross-sell').forEach(function (root) {
          refreshCrossSellAddButtonLabels(root);
        });
        var root = getDrawerCrossSellRoot();
        if (!isMobileDrawerLayout()) {
          if (root) {
            scheduleDesktopCrossSellAnchor(root);
          }
          syncMobileBodyScrollOnly();
          return;
        }
        if (root) {
          scheduleMobileCrossSellLayoutSync(root);
        } else {
          requestAnimationFrame(syncMobileBodyScrollOnly);
        }
      });

      document.addEventListener('cart-drawer:refreshed', function () {
        var debugEnabled = applyCrossSellDebugGate();
        var restored = restoreCrossSellAfterDrawerRefresh();
        var cartMutation = pendingDrawerCartMutation;
        pendingDrawerCartMutation = null;
        var drawerRoots = restored
          ? [restored]
          : Array.prototype.slice.call(document.querySelectorAll('cart-drawer .cross-sell--drawer-items'));

        function syncDrawerCrossSellRoot(root) {
          if (!root) {
            return;
          }

          if (cartMutation) {
            refreshCrossSellFromCart(root, cartMutation.cart, {
              cartKey: cartMutation.cartKey,
              force: true,
            });
            return;
          }

          var domEngine = readEngine(root);
          saveEngineSnapshot(domEngine);
          var cartKey = buildCartMutationKey({ items: domEngine.cart, item_count: domEngine.cart.length });

          if (!root.hidden && !restored && (isRootCartProcessed(root, cartKey) || isRootCartPending(root, cartKey))) {
            ensureCrossSellVisibleIfHasProposals(root);
            return;
          }

          refreshCrossSellFromCart(root, null, {
            cartKey: cartKey,
            force: !!(restored || root.hidden),
          });
        }

        if (!drawerRoots.length) {
          drawerRoots = Array.prototype.slice.call(document.querySelectorAll('cart-drawer .cross-sell--drawer-items'));
        }

        drawerRoots.forEach(syncDrawerCrossSellRoot);

        if (debugEnabled) {
          ensureDebugModal().then(function () {
            restoreDebugOpen();
            syncDebugButtons(isDebugOpen(debugRoot()));
          });
        }
        var layoutRoot = restored || getDrawerCrossSellRoot();
        if (layoutRoot) {
          scheduleDesktopCrossSellAnchor(layoutRoot);
          scheduleMobileCrossSellLayoutSync(layoutRoot);
          watchMobileCrossSellLayout(layoutRoot);
        } else {
          requestAnimationFrame(syncMobileBodyScrollOnly);
        }
      });
    }

    function init() {
      var debugEnabled = applyCrossSellDebugGate();
      bindDebugToggle();
      if (debugEnabled) {
        bindDebugDrawerOpen();
        syncDebugButtons(false);
        ensureDebugModal().then(function (debug) {
          attachDebugModalToBody(debug);
        });
      }
      bindCartListeners();
      document.querySelectorAll('.cross-sell').forEach(function (root) {
        initEngine(root, { silent: false });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
